import React from 'react';

// Styles
import styles from './info.module.css'

const teamNameById = {
    "44": "BOSTON BRUINS",
    "45": "BUFFALO SABRES",
    "46": "CALGARY FLAMES",
    "47": "CAROLINA HURRICANES",
    "48": "CHICAGO BLACKHAWKS",
    "49": "COLORADO AVALANCHE",
    "50": "COLUMBUS BLUE JACKETS",
    "51": "DALLAS STARS *ENLARGE IMAGE",
    "52": "DETROIT RED WINGS",
    "53": "EDMONTON OILERS",
    "54": "FLORIDA PANTHERS",
    "55": "LOS ANGELES KINGS",
    "56": "MINNESOTA WILD",
    "57": "MONTREAL CANADIENS",
    "58": "NASHVILLE PREDATORS *ENLARGE IMAGE",
    "59": "NEW JERSEY DEVILS",
    "60": "NEW YORK ISLANDERS",
    "61": "OTTAWA SENATORS",
    "62": "PHILADELPHIA FLYERS",
    "63": "UTAH MAMMOTH",
    "64": "PITTSBURGH PENGUINS",
    "65": "SAN JOSE SHARKS",
    "66": "ST. LOUIS BLUES",
    "67": "TAMPA BAY LIGHTNING",
    "68": "TORONTO MAPLE LEAFS",
    "69": "VANCOUVER CANUCKS",
    "70": "WASHINGTON CAPITALS",
    "73": "NEW YORK RANGERS",
    "142": "WINNIPEG JETS",
    "163": "SEATTLE KRAKEN *ENLARGE IMAGE"
}

const jerseyTypeById = {
    "393": "DARK 26/27",
    "394": "WHITE 26/27",
    "395": "WHITE 26/27",
    "396": "DARK 26/27",
    "397": "DARK 26/27",
    "398": "ALT 24/25",
    "401": "DARK 26/27",
    "402": "WHITE 26/27",
    "403": "DARK 26/27",
    "404": "WHITE 26/27",
    "405": "DARK 26/27",
    "406": "WHITE 26/27",
    "409": "DARK 26/27",
    "410": "WHITE 26/27",
    "417": "DARK 26/27",
    "419": "WHITE 26/27",
    "420": "DARK 26/27",
    "421": "WHITE 26/27",
    "422": "DARK 26/27",
    "423": "WHITE 26/27",
    "424": "DARK 26/27",
    "427": "DARK 26/27",
    "428": "WHITE 26/27",
    "429": "DARK 26/27",
    "430": "WHITE 26/27",
    "431": "WHITE 26/27",
    "443": "DARK 26/27",
    "444": "WHITE 26/27",
    "445": "DARK 26/27",
    "446": "WHITE 26/27",
    "485": "DARK 26/27",
    "491": "DARK 26/27",
    "508": "WHITE 26/27",
    "516": "DARK 26/27",
    "527": "WHITE 26/27",
    "531": "DARK 26/27",
    "532": "WHITE 26/27",
    "534": "WHITE 26/27",
    "552": "WHITE 26/27",
    "553": "DARK 26/27",
    "554": "WHITE 26/27",
    "555": "WHITE 26/27",
    "580": "DARK 26/27",
    "581": "WHITE 26/27",
    "582": "DARK 26/27",
    "584": "DARK 26/27",
    "621": "DARK 26/27",
    "622": "WHITE 26/27",
    "625": "WHITE 26/27",
    "626": "DARK 26/27",
    "627": "WHITE 26/27",
    "638": "DARK 26/27",
    "639": "ALT 24/25",
    "640": "ALT 24/25",
    "641": "DARK 26/27",
    "642": "DARK 26/27",
    "643": "ALT 24/25",
    "649": "ALT 24/25",
    "650": "ALT 24/25",
    "651": "ALT 24/25",
    "659": "WHITE 26/27",
    "660": "ALT 24/25",
    "667": "ALT 24/25",
    "700": "DARK 26/27",
    "701": "WHITE 26/27",
    "702": "WHITE 26/27",
    "706": "WHITE 26/27",
    "707": "DARK 26/27",
    "708": "WHITE 26/27",
    "709": "ALT 24/25",
    "710": "ALT 25/26",
    "711": "ALT 24/25",
    "712": "ALT 24/25"
}

const playersById = {
    "13860": {
        "Name": "Swayman",
        "Number": "1",
        "AorC": "          "
    },
    "13861": {
        "Name": "Lohrei",
        "Number": "6",
        "AorC": "          "
    },
    "13862": {
        "Name": "Mittelstadt",
        "Number": "11",
        "AorC": "          "
    },
    "13863": {
        "Name": "Zacha",
        "Number": "18",
        "AorC": "          "
    },
    "13864": {
        "Name": "Beecher",
        "Number": "19",
        "AorC": "          "
    },
    "13865": {
        "Name": "Jokiharju",
        "Number": "20",
        "AorC": "          "
    },
    "13866": {
        "Name": "Peeke",
        "Number": "26",
        "AorC": "          "
    },
    "13867": {
        "Name": "Lindholm",
        "Number": "27",
        "AorC": "          "
    },
    "13868": {
        "Name": "Lindholm",
        "Number": "28",
        "AorC": "          "
    },
    "13869": {
        "Name": "Geekie",
        "Number": "39",
        "AorC": "          "
    },
    "13870": {
        "Name": "Harris",
        "Number": "43",
        "AorC": "          "
    },
    "13871": {
        "Name": "Kastelic",
        "Number": "47",
        "AorC": "          "
    },
    "13872": {
        "Name": "Viel",
        "Number": "48",
        "AorC": "          "
    },
    "13873": {
        "Name": "Kuraly",
        "Number": "52",
        "AorC": "          "
    },
    "13874": {
        "Name": "Korpisalo",
        "Number": "70",
        "AorC": "          "
    },
    "13875": {
        "Name": "Arvidsson",
        "Number": "71",
        "AorC": "          "
    },
    "13876": {
        "Name": "McAvoy",
        "Number": "73",
        "AorC": "          "
    },
    "13877": {
        "Name": "Eyssimont",
        "Number": "81",
        "AorC": "          "
    },
    "13878": {
        "Name": "Jeannot",
        "Number": "84",
        "AorC": "          "
    },
    "13879": {
        "Name": "Pastrnak",
        "Number": "88",
        "AorC": "A         "
    },
    "13880": {
        "Name": "Zadorov",
        "Number": "91",
        "AorC": "          "
    },
    "13881": {
        "Name": "Khusnutdinov",
        "Number": "92",
        "AorC": "          "
    },
    "13882": {
        "Name": "Minten",
        "Number": "93",
        "AorC": "          "
    },
    "13883": {
        "Name": "Petry",
        "Number": "2",
        "AorC": "          "
    },
    "13884": {
        "Name": "Jones",
        "Number": "3",
        "AorC": "          "
    },
    "13885": {
        "Name": "Ekblad",
        "Number": "5",
        "AorC": "          "
    },
    "13886": {
        "Name": "Kulikov",
        "Number": "7",
        "AorC": "          "
    },
    "13887": {
        "Name": "Bennett",
        "Number": "9",
        "AorC": "          "
    },
    "13888": {
        "Name": "Greer",
        "Number": "10",
        "AorC": "          "
    },
    "13889": {
        "Name": "Samoskevich",
        "Number": "11",
        "AorC": "          "
    },
    "13890": {
        "Name": "Gadjovich",
        "Number": "12",
        "AorC": "          "
    },
    "13891": {
        "Name": "Reinhart",
        "Number": "13",
        "AorC": "          "
    },
    "13892": {
        "Name": "Motte",
        "Number": "14",
        "AorC": "          "
    },
    "13893": {
        "Name": "Lundell",
        "Number": "15",
        "AorC": "          "
    },
    "13894": {
        "Name": "Barkov",
        "Number": "16",
        "AorC": "C         "
    },
    "13895": {
        "Name": "Rodrigues",
        "Number": "17",
        "AorC": "          "
    },
    "13896": {
        "Name": "Gregor",
        "Number": "18",
        "AorC": "          "
    },
    "13897": {
        "Name": "Tkachuk",
        "Number": "19",
        "AorC": "          "
    },
    "13898": {
        "Name": "Verhaeghe",
        "Number": "23",
        "AorC": "          "
    },
    "13899": {
        "Name": "Balinskis",
        "Number": "26",
        "AorC": "          "
    },
    "13900": {
        "Name": "Luostarinen",
        "Number": "27",
        "AorC": "          "
    },
    "13901": {
        "Name": "Tarasov",
        "Number": "40",
        "AorC": "          "
    },
    "13902": {
        "Name": "Forsling",
        "Number": "42",
        "AorC": "          "
    },
    "13903": {
        "Name": "Marchand",
        "Number": "63",
        "AorC": "          "
    },
    "13904": {
        "Name": "Boqvist",
        "Number": "70",
        "AorC": "          "
    },
    "13905": {
        "Name": "Kunin",
        "Number": "71",
        "AorC": "          "
    },
    "13906": {
        "Name": "Bobrovsky",
        "Number": "72",
        "AorC": "          "
    },
    "13907": {
        "Name": "Andonovski",
        "Number": "75",
        "AorC": "          "
    },
    "13908": {
        "Name": "Mikkola",
        "Number": "77",
        "AorC": "          "
    },
    "13909": {
        "Name": "Schwindt",
        "Number": "79",
        "AorC": "          "
    },
    "13910": {
        "Name": "Nosek",
        "Number": "92",
        "AorC": "          "
    },
    "13911": {
        "Name": "Geekie",
        "Number": "14",
        "AorC": "          "
    },
    "13912": {
        "Name": "Stachowiak",
        "Number": "19",
        "AorC": "          "
    },
    "13913": {
        "Name": "Paul",
        "Number": "20",
        "AorC": "          "
    },
    "13914": {
        "Name": "Point",
        "Number": "21",
        "AorC": "          "
    },
    "13915": {
        "Name": "Bjorkstrand",
        "Number": "22",
        "AorC": "          "
    },
    "13916": {
        "Name": "Crozier",
        "Number": "24",
        "AorC": "          "
    },
    "13917": {
        "Name": "McDonagh",
        "Number": "27",
        "AorC": "          "
    },
    "13918": {
        "Name": "Girgensons",
        "Number": "28",
        "AorC": "          "
    },
    "13919": {
        "Name": "Holmberg",
        "Number": "29",
        "AorC": "          "
    },
    "13920": {
        "Name": "Johansson",
        "Number": "31",
        "AorC": "          "
    },
    "13921": {
        "Name": "Gourde",
        "Number": "37",
        "AorC": "          "
    },
    "13922": {
        "Name": "Hagel",
        "Number": "38",
        "AorC": "          "
    },
    "13923": {
        "Name": "Chaffee",
        "Number": "41",
        "AorC": "          "
    },
    "13924": {
        "Name": "Raddysh",
        "Number": "43",
        "AorC": "          "
    },
    "13925": {
        "Name": "Sabourin",
        "Number": "46",
        "AorC": "          "
    },
    "13926": {
        "Name": "D'Astous",
        "Number": "51",
        "AorC": "          "
    },
    "13927": {
        "Name": "Duke",
        "Number": "53",
        "AorC": "          "
    },
    "13928": {
        "Name": "Guentzel",
        "Number": "59",
        "AorC": "          "
    },
    "13929": {
        "Name": "Katchouk",
        "Number": "61",
        "AorC": "          "
    },
    "13930": {
        "Name": "Finley",
        "Number": "62",
        "AorC": "          "
    },
    "13931": {
        "Name": "Cirelli",
        "Number": "71",
        "AorC": "          "
    },
    "13932": {
        "Name": "Schmidt",
        "Number": "76",
        "AorC": "          "
    },
    "13933": {
        "Name": "Hedman",
        "Number": "77",
        "AorC": "C         "
    },
    "13934": {
        "Name": "Lilleberg",
        "Number": "78",
        "AorC": "          "
    },
    "13935": {
        "Name": "Cernak",
        "Number": "81",
        "AorC": "          "
    },
    "13936": {
        "Name": "Kucherov",
        "Number": "86",
        "AorC": "          "
    },
    "13937": {
        "Name": "Vasilevskiy",
        "Number": "88",
        "AorC": "          "
    },
    "13938": {
        "Name": "Moser",
        "Number": "90",
        "AorC": "          "
    },
    "13939": {
        "Name": "Goncalves",
        "Number": "93",
        "AorC": "          "
    },
    "13943": {
        "Name": "Gostisbehere",
        "Number": "4",
        "AorC": "          "
    },
    "13944": {
        "Name": "Chatfield",
        "Number": "5",
        "AorC": "          "
    },
    "13945": {
        "Name": "Reilly",
        "Number": "6",
        "AorC": "          "
    },
    "13946": {
        "Name": "Staal",
        "Number": "11",
        "AorC": "C         "
    },
    "13947": {
        "Name": "Miller",
        "Number": "19",
        "AorC": "          "
    },
    "13948": {
        "Name": "Aho",
        "Number": "20",
        "AorC": "          "
    },
    "13949": {
        "Name": "Nikishin",
        "Number": "21",
        "AorC": "          "
    },
    "13950": {
        "Name": "Stankoven",
        "Number": "22",
        "AorC": "          "
    },
    "13951": {
        "Name": "Jarvis",
        "Number": "24",
        "AorC": "          "
    },
    "13952": {
        "Name": "Walker",
        "Number": "26",
        "AorC": "          "
    },
    "13953": {
        "Name": "Ehlers",
        "Number": "27",
        "AorC": "          "
    },
    "13954": {
        "Name": "Carrier",
        "Number": "28",
        "AorC": "          "
    },
    "13955": {
        "Name": "Andersen",
        "Number": "31",
        "AorC": "          "
    },
    "13956": {
        "Name": "Svechnikov",
        "Number": "37",
        "AorC": "          "
    },
    "13957": {
        "Name": "Martinook",
        "Number": "48",
        "AorC": "          "
    },
    "13958": {
        "Name": "Robinson",
        "Number": "50",
        "AorC": "          "
    },
    "13959": {
        "Name": "Kochetkov",
        "Number": "52",
        "AorC": "          "
    },
    "13960": {
        "Name": "Blake",
        "Number": "53",
        "AorC": "          "
    },
    "13961": {
        "Name": "Jaaska",
        "Number": "54",
        "AorC": "          "
    },
    "13962": {
        "Name": "Legault",
        "Number": "62",
        "AorC": "          "
    },
    "13963": {
        "Name": "Hall",
        "Number": "71",
        "AorC": "          "
    },
    "13964": {
        "Name": "Slavin",
        "Number": "74",
        "AorC": "          "
    },
    "13965": {
        "Name": "Jankowski",
        "Number": "77",
        "AorC": "          "
    },
    "13966": {
        "Name": "Kotkaniemi",
        "Number": "82",
        "AorC": "          "
    },
    "13967": {
        "Name": "Pelech",
        "Number": "3",
        "AorC": "          "
    },
    "13968": {
        "Name": "Pulock",
        "Number": "6",
        "AorC": "          "
    },
    "13969": {
        "Name": "Tsyplakov",
        "Number": "7",
        "AorC": "          "
    },
    "13970": {
        "Name": "Holmstrom",
        "Number": "10",
        "AorC": "          "
    },
    "13971": {
        "Name": "Duclair",
        "Number": "11",
        "AorC": "          "
    },
    "13972": {
        "Name": "Barzal",
        "Number": "13",
        "AorC": "          "
    },
    "13973": {
        "Name": "Horvat",
        "Number": "14",
        "AorC": "A         "
    },
    "13974": {
        "Name": "Gatcomb",
        "Number": "16",
        "AorC": "          "
    },
    "13975": {
        "Name": "Engvall",
        "Number": "18",
        "AorC": "          "
    },
    "13976": {
        "Name": "Palmieri",
        "Number": "21",
        "AorC": "          "
    },
    "13977": {
        "Name": "Mayfield",
        "Number": "24",
        "AorC": "          "
    },
    "13978": {
        "Name": "Terry",
        "Number": "25",
        "AorC": "          "
    },
    "13979": {
        "Name": "Lee",
        "Number": "27",
        "AorC": "          "
    },
    "13980": {
        "Name": "Romanov",
        "Number": "28",
        "AorC": "          "
    },
    "13981": {
        "Name": "Drouin",
        "Number": "29",
        "AorC": "          "
    },
    "13982": {
        "Name": "Sorokin",
        "Number": "30",
        "AorC": "          "
    },
    "13983": {
        "Name": "MacLean",
        "Number": "32",
        "AorC": "          "
    },
    "13984": {
        "Name": "Rittich",
        "Number": "33",
        "AorC": "          "
    },
    "13985": {
        "Name": "Boqvist",
        "Number": "34",
        "AorC": "          "
    },
    "13986": {
        "Name": "George",
        "Number": "36",
        "AorC": "          "
    },
    "13987": {
        "Name": "Varlamov",
        "Number": "40",
        "AorC": "          "
    },
    "13988": {
        "Name": "Pageau",
        "Number": "44",
        "AorC": "          "
    },
    "13989": {
        "Name": "Day",
        "Number": "47",
        "AorC": "          "
    },
    "13990": {
        "Name": "Schaefer",
        "Number": "48",
        "AorC": "          "
    },
    "13991": {
        "Name": "Shabanov",
        "Number": "49",
        "AorC": "          "
    },
    "13992": {
        "Name": "Heineman",
        "Number": "51",
        "AorC": "          "
    },
    "13993": {
        "Name": "Kuefler",
        "Number": "52",
        "AorC": "          "
    },
    "13994": {
        "Name": "Cizikas",
        "Number": "53",
        "AorC": "          "
    },
    "13995": {
        "Name": "Berg",
        "Number": "55",
        "AorC": "          "
    },
    "13996": {
        "Name": "Dorrington",
        "Number": "56",
        "AorC": "          "
    },
    "13997": {
        "Name": "Mitton",
        "Number": "62",
        "AorC": "          "
    },
    "13998": {
        "Name": "Ritchie",
        "Number": "64",
        "AorC": "          "
    },
    "13999": {
        "Name": "Nurmi",
        "Number": "72",
        "AorC": "          "
    },
    "14000": {
        "Name": "Bear",
        "Number": "74",
        "AorC": "          "
    },
    "14001": {
        "Name": "Gahagen",
        "Number": "75",
        "AorC": "          "
    },
    "14002": {
        "Name": "DeAngelo",
        "Number": "77",
        "AorC": "          "
    },
    "14003": {
        "Name": "Drew",
        "Number": "81",
        "AorC": "          "
    },
    "14004": {
        "Name": "Rowe",
        "Number": "85",
        "AorC": "          "
    },
    "14005": {
        "Name": "McDonald",
        "Number": "89",
        "AorC": "          "
    },
    "14006": {
        "Name": "McGroarty",
        "Number": "2",
        "AorC": "          "
    },
    "14007": {
        "Name": "St. Ivany",
        "Number": "3",
        "AorC": "          "
    },
    "14008": {
        "Name": "Shea",
        "Number": "5",
        "AorC": "          "
    },
    "14009": {
        "Name": "Kettles",
        "Number": "7",
        "AorC": "          "
    },
    "14010": {
        "Name": "Howe",
        "Number": "9",
        "AorC": "          "
    },
    "14011": {
        "Name": "Hallander",
        "Number": "11",
        "AorC": "          "
    },
    "14012": {
        "Name": "Hayes",
        "Number": "13",
        "AorC": "          "
    },
    "14013": {
        "Name": "Brazeau",
        "Number": "16",
        "AorC": "          "
    },
    "14014": {
        "Name": "Rust",
        "Number": "17",
        "AorC": "          "
    },
    "14015": {
        "Name": "Novak",
        "Number": "18",
        "AorC": "          "
    },
    "14016": {
        "Name": "Dewar",
        "Number": "19",
        "AorC": "          "
    },
    "14017": {
        "Name": "Dumba",
        "Number": "24",
        "AorC": "          "
    },
    "14018": {
        "Name": "Wotherspoon",
        "Number": "28",
        "AorC": "          "
    },
    "14019": {
        "Name": "Blomqvist",
        "Number": "30",
        "AorC": "          "
    },
    "14020": {
        "Name": "Jarry",
        "Number": "35",
        "AorC": "          "
    },
    "14021": {
        "Name": "Silovs",
        "Number": "37",
        "AorC": "          "
    },
    "14022": {
        "Name": "Mantha",
        "Number": "39",
        "AorC": "          "
    },
    "14023": {
        "Name": "Koivunen",
        "Number": "41",
        "AorC": "          "
    },
    "14024": {
        "Name": "Brunicke",
        "Number": "45",
        "AorC": "          "
    },
    "14025": {
        "Name": "Lizotte",
        "Number": "46",
        "AorC": "          "
    },
    "14026": {
        "Name": "Tomasino",
        "Number": "53",
        "AorC": "          "
    },
    "14027": {
        "Name": "Acciari",
        "Number": "55",
        "AorC": "          "
    },
    "14028": {
        "Name": "Letang",
        "Number": "58",
        "AorC": "          "
    },
    "14029": {
        "Name": "Karlsson",
        "Number": "65",
        "AorC": "          "
    },
    "14030": {
        "Name": "Rakell",
        "Number": "67",
        "AorC": "          "
    },
    "14031": {
        "Name": "Malkin",
        "Number": "71",
        "AorC": "          "
    },
    "14032": {
        "Name": "Zonnon",
        "Number": "72",
        "AorC": "          "
    },
    "14033": {
        "Name": "Clifton",
        "Number": "75",
        "AorC": "          "
    },
    "14034": {
        "Name": "Kindel",
        "Number": "81",
        "AorC": "          "
    },
    "14035": {
        "Name": "Jones",
        "Number": "82",
        "AorC": "          "
    },
    "14036": {
        "Name": "Crosby",
        "Number": "87",
        "AorC": "C         "
    },
    "14037": {
        "Name": "Murphy",
        "Number": "5",
        "AorC": "          "
    },
    "14038": {
        "Name": "Rinzel",
        "Number": "6",
        "AorC": "          "
    },
    "14039": {
        "Name": "Donato",
        "Number": "8",
        "AorC": "          "
    },
    "14040": {
        "Name": "Dickinson",
        "Number": "16",
        "AorC": "          "
    },
    "14041": {
        "Name": "Foligno",
        "Number": "17",
        "AorC": "C         "
    },
    "14042": {
        "Name": "Anderson",
        "Number": "22",
        "AorC": "          "
    },
    "14043": {
        "Name": "Lafferty",
        "Number": "24",
        "AorC": "          "
    },
    "14044": {
        "Name": "Burakovsky",
        "Number": "28",
        "AorC": "          "
    },
    "14045": {
        "Name": "Knight",
        "Number": "30",
        "AorC": "          "
    },
    "14046": {
        "Name": "Dach",
        "Number": "34",
        "AorC": "          "
    },
    "14047": {
        "Name": "Del Mastro",
        "Number": "38",
        "AorC": "          "
    },
    "14048": {
        "Name": "Brossoit",
        "Number": "39",
        "AorC": "          "
    },
    "14049": {
        "Name": "Soderblom",
        "Number": "40",
        "AorC": "          "
    },
    "14050": {
        "Name": "Kaiser",
        "Number": "44",
        "AorC": "          "
    },
    "14051": {
        "Name": "Crevier",
        "Number": "46",
        "AorC": "          "
    },
    "14052": {
        "Name": "Grzelcyk",
        "Number": "48",
        "AorC": "          "
    },
    "14053": {
        "Name": "Levshunov",
        "Number": "55",
        "AorC": "          "
    },
    "14054": {
        "Name": "Bertuzzi",
        "Number": "59",
        "AorC": "          "
    },
    "14055": {
        "Name": "Vlasic",
        "Number": "72",
        "AorC": "          "
    },
    "14056": {
        "Name": "Reichel",
        "Number": "73",
        "AorC": "          "
    },
    "14057": {
        "Name": "Slaggert",
        "Number": "84",
        "AorC": "          "
    },
    "14058": {
        "Name": "Teravainen",
        "Number": "86",
        "AorC": "          "
    },
    "14059": {
        "Name": "Nazar",
        "Number": "91",
        "AorC": "          "
    },
    "14060": {
        "Name": "Mikheyev",
        "Number": "95",
        "AorC": "          "
    },
    "14061": {
        "Name": "Bedard",
        "Number": "98",
        "AorC": "          "
    },
    "14062": {
        "Name": "Middleton",
        "Number": "5",
        "AorC": "          "
    },
    "14063": {
        "Name": "Faber",
        "Number": "7",
        "AorC": "          "
    },
    "14064": {
        "Name": "Buium",
        "Number": "8",
        "AorC": "          "
    },
    "14065": {
        "Name": "Boldy",
        "Number": "12",
        "AorC": "          "
    },
    "14066": {
        "Name": "Trenin",
        "Number": "13",
        "AorC": "          "
    },
    "14067": {
        "Name": "Eriksson Ek",
        "Number": "14",
        "AorC": "          "
    },
    "14068": {
        "Name": "Foligno",
        "Number": "17",
        "AorC": "          "
    },
    "14069": {
        "Name": "Hinostroza",
        "Number": "18",
        "AorC": "          "
    },
    "14070": {
        "Name": "Yurov",
        "Number": "22",
        "AorC": "          "
    },
    "14071": {
        "Name": "Rossi",
        "Number": "23",
        "AorC": "          "
    },
    "14072": {
        "Name": "Bogosian",
        "Number": "24",
        "AorC": "          "
    },
    "14073": {
        "Name": "Brodin",
        "Number": "25",
        "AorC": "          "
    },
    "14074": {
        "Name": "Butler",
        "Number": "27",
        "AorC": "          "
    },
    "14075": {
        "Name": "Ohgren",
        "Number": "28",
        "AorC": "          "
    },
    "14076": {
        "Name": "Wallstedt",
        "Number": "30",
        "AorC": "          "
    },
    "14077": {
        "Name": "Gustavsson",
        "Number": "32",
        "AorC": "          "
    },
    "14078": {
        "Name": "Zuccarello",
        "Number": "36",
        "AorC": "          "
    },
    "14079": {
        "Name": "Hartman",
        "Number": "38",
        "AorC": "          "
    },
    "14080": {
        "Name": "Spurgeon",
        "Number": "46",
        "AorC": "C         "
    },
    "14081": {
        "Name": "Hunt",
        "Number": "48",
        "AorC": "          "
    },
    "14082": {
        "Name": "Jiricek",
        "Number": "55",
        "AorC": "          "
    },
    "14083": {
        "Name": "Milne",
        "Number": "60",
        "AorC": "          "
    },
    "14084": {
        "Name": "Sturm",
        "Number": "78",
        "AorC": "          "
    },
    "14085": {
        "Name": "Leskovar",
        "Number": "81",
        "AorC": "          "
    },
    "14086": {
        "Name": "Johansson",
        "Number": "90",
        "AorC": "          "
    },
    "14087": {
        "Name": "Tarasenko",
        "Number": "91",
        "AorC": "          "
    },
    "14088": {
        "Name": "Kaprizov",
        "Number": "97",
        "AorC": "          "
    },
    "14089": {
        "Name": "Maatta",
        "Number": "2",
        "AorC": "          "
    },
    "14090": {
        "Name": "Valimaki",
        "Number": "4",
        "AorC": "          "
    },
    "14091": {
        "Name": "Marino",
        "Number": "6",
        "AorC": "          "
    },
    "14092": {
        "Name": "Schmaltz",
        "Number": "8",
        "AorC": "          "
    },
    "14093": {
        "Name": "Keller",
        "Number": "9",
        "AorC": "C         "
    },
    "14094": {
        "Name": "Guenther",
        "Number": "11",
        "AorC": "          "
    },
    "14095": {
        "Name": "Iginla",
        "Number": "12",
        "AorC": "          "
    },
    "14096": {
        "Name": "Tanev",
        "Number": "13",
        "AorC": "          "
    },
    "14097": {
        "Name": "Kerfoot",
        "Number": "15",
        "AorC": "          "
    },
    "14098": {
        "Name": "But",
        "Number": "19",
        "AorC": "          "
    },
    "14099": {
        "Name": "McBain",
        "Number": "22",
        "AorC": "          "
    },
    "14100": {
        "Name": "Simashev",
        "Number": "26",
        "AorC": "          "
    },
    "14101": {
        "Name": "Hayton",
        "Number": "27",
        "AorC": "          "
    },
    "14102": {
        "Name": "Cole",
        "Number": "28",
        "AorC": "          "
    },
    "14103": {
        "Name": "Thornton",
        "Number": "34",
        "AorC": "          "
    },
    "14104": {
        "Name": "Agozzino",
        "Number": "36",
        "AorC": "          "
    },
    "14105": {
        "Name": "O'Brien",
        "Number": "38",
        "AorC": "          "
    },
    "14106": {
        "Name": "Vanecek",
        "Number": "41",
        "AorC": "          "
    },
    "14107": {
        "Name": "Durzi",
        "Number": "50",
        "AorC": "          "
    },
    "14108": {
        "Name": "Carcone",
        "Number": "53",
        "AorC": "          "
    },
    "14109": {
        "Name": "Goldsmith",
        "Number": "54",
        "AorC": "          "
    },
    "14110": {
        "Name": "Yamamoto",
        "Number": "56",
        "AorC": "          "
    },
    "14111": {
        "Name": "DeSimone",
        "Number": "57",
        "AorC": "          "
    },
    "14112": {
        "Name": "Crouse",
        "Number": "67",
        "AorC": "          "
    },
    "14113": {
        "Name": "Vejmelka",
        "Number": "70",
        "AorC": "          "
    },
    "14114": {
        "Name": "Peterka",
        "Number": "77",
        "AorC": "          "
    },
    "14115": {
        "Name": "Stenlund",
        "Number": "82",
        "AorC": "          "
    },
    "14116": {
        "Name": "Schmidt",
        "Number": "88",
        "AorC": "          "
    },
    "14117": {
        "Name": "Cooley",
        "Number": "92",
        "AorC": "          "
    },
    "14118": {
        "Name": "Sergachev",
        "Number": "98",
        "AorC": "          "
    },
    "14119": {
        "Name": "Dumoulin",
        "Number": "2",
        "AorC": "          "
    },
    "14120": {
        "Name": "Ceci",
        "Number": "5",
        "AorC": "          "
    },
    "14121": {
        "Name": "Edmundson",
        "Number": "6",
        "AorC": "          "
    },
    "14122": {
        "Name": "Burroughs",
        "Number": "7",
        "AorC": "          "
    },
    "14123": {
        "Name": "Doughty",
        "Number": "8",
        "AorC": "          "
    },
    "14124": {
        "Name": "Kempe",
        "Number": "9",
        "AorC": "          "
    },
    "14125": {
        "Name": "Perry",
        "Number": "10",
        "AorC": "          "
    },
    "14126": {
        "Name": "Kopitar",
        "Number": "11",
        "AorC": "C         "
    },
    "14127": {
        "Name": "Moore",
        "Number": "12",
        "AorC": "          "
    },
    "14128": {
        "Name": "Laferriere",
        "Number": "14",
        "AorC": "          "
    },
    "14129": {
        "Name": "Turcotte",
        "Number": "15",
        "AorC": "          "
    },
    "14130": {
        "Name": "Fiala",
        "Number": "22",
        "AorC": "          "
    },
    "14131": {
        "Name": "Danault",
        "Number": "24",
        "AorC": "          "
    },
    "14132": {
        "Name": "Copley",
        "Number": "29",
        "AorC": "          "
    },
    "14133": {
        "Name": "Forsberg",
        "Number": "31",
        "AorC": "          "
    },
    "14134": {
        "Name": "Kuemper",
        "Number": "35",
        "AorC": "          "
    },
    "14135": {
        "Name": "Foegele",
        "Number": "37",
        "AorC": "          "
    },
    "14136": {
        "Name": "Malott",
        "Number": "39",
        "AorC": "          "
    },
    "14137": {
        "Name": "Armia",
        "Number": "40",
        "AorC": "          "
    },
    "14138": {
        "Name": "Moverare",
        "Number": "43",
        "AorC": "          "
    },
    "14139": {
        "Name": "Anderson",
        "Number": "44",
        "AorC": "          "
    },
    "14140": {
        "Name": "Doty",
        "Number": "45",
        "AorC": "          "
    },
    "14141": {
        "Name": "Isogai",
        "Number": "46",
        "AorC": "          "
    },
    "14142": {
        "Name": "Byfield",
        "Number": "55",
        "AorC": "          "
    },
    "14143": {
        "Name": "Hughes",
        "Number": "62",
        "AorC": "          "
    },
    "14144": {
        "Name": "Helenius",
        "Number": "79",
        "AorC": "          "
    },
    "14145": {
        "Name": "Booth",
        "Number": "81",
        "AorC": "          "
    },
    "14146": {
        "Name": "Clarke",
        "Number": "92",
        "AorC": "          "
    },
    "14147": {
        "Name": "Kuzmenko",
        "Number": "96",
        "AorC": "          "
    },
    "14148": {
        "Name": "Woo",
        "Number": "4",
        "AorC": "          "
    },
    "14149": {
        "Name": "Boeser",
        "Number": "6",
        "AorC": "          "
    },
    "14150": {
        "Name": "Joseph",
        "Number": "7",
        "AorC": "          "
    },
    "14151": {
        "Name": "Garland",
        "Number": "8",
        "AorC": "          "
    },
    "14152": {
        "Name": "Bains",
        "Number": "13",
        "AorC": "          "
    },
    "14153": {
        "Name": "Hronek",
        "Number": "17",
        "AorC": "          "
    },
    "14154": {
        "Name": "O'Connor",
        "Number": "18",
        "AorC": "          "
    },
    "14155": {
        "Name": "Hoglander",
        "Number": "21",
        "AorC": "          "
    },
    "14156": {
        "Name": "Lekkerimaki",
        "Number": "23",
        "AorC": "          "
    },
    "14157": {
        "Name": "Pettersson",
        "Number": "25",
        "AorC": "          "
    },
    "14158": {
        "Name": "Forbort",
        "Number": "27",
        "AorC": "          "
    },
    "14159": {
        "Name": "Pettersson",
        "Number": "29",
        "AorC": "          "
    },
    "14160": {
        "Name": "Lankinen",
        "Number": "32",
        "AorC": "          "
    },
    "14161": {
        "Name": "Demko",
        "Number": "35",
        "AorC": "          "
    },
    "14162": {
        "Name": "Pettersson",
        "Number": "40",
        "AorC": "          "
    },
    "14163": {
        "Name": "Hughes",
        "Number": "43",
        "AorC": "          "
    },
    "14164": {
        "Name": "Sherwood",
        "Number": "44",
        "AorC": "          "
    },
    "14165": {
        "Name": "Blueger",
        "Number": "53",
        "AorC": "          "
    },
    "14166": {
        "Name": "Raty",
        "Number": "54",
        "AorC": "          "
    },
    "14167": {
        "Name": "Brisebois",
        "Number": "55",
        "AorC": "          "
    },
    "14168": {
        "Name": "Myers",
        "Number": "57",
        "AorC": "          "
    },
    "14169": {
        "Name": "Chytil",
        "Number": "72",
        "AorC": "          "
    },
    "14170": {
        "Name": "DeBrusk",
        "Number": "74",
        "AorC": "          "
    },
    "14171": {
        "Name": "Cootes",
        "Number": "80",
        "AorC": "          "
    },
    "14172": {
        "Name": "Kane",
        "Number": "91",
        "AorC": "          "
    },
    "14173": {
        "Name": "Karlsson",
        "Number": "94",
        "AorC": "          "
    },
    "14174": {
        "Name": "Luukkonen",
        "Number": "1",
        "AorC": "          "
    },
    "14175": {
        "Name": "Byram",
        "Number": "4",
        "AorC": "          "
    },
    "14176": {
        "Name": "Benson",
        "Number": "6",
        "AorC": "          "
    },
    "14177": {
        "Name": "Kesselring",
        "Number": "8",
        "AorC": "          "
    },
    "14178": {
        "Name": "Norris",
        "Number": "9",
        "AorC": "          "
    },
    "14179": {
        "Name": "Greenway",
        "Number": "12",
        "AorC": "          "
    },
    "14180": {
        "Name": "Danforth",
        "Number": "15",
        "AorC": "          "
    },
    "14181": {
        "Name": "Turcotte",
        "Number": "15",
        "AorC": "          "
    },
    "14182": {
        "Name": "Zucker",
        "Number": "17",
        "AorC": "          "
    },
    "14183": {
        "Name": "Krebs",
        "Number": "19",
        "AorC": "          "
    },
    "14184": {
        "Name": "Kulich",
        "Number": "20",
        "AorC": "          "
    },
    "14185": {
        "Name": "Timmins",
        "Number": "21",
        "AorC": "          "
    },
    "14186": {
        "Name": "Quinn",
        "Number": "22",
        "AorC": "          "
    },
    "14187": {
        "Name": "Samuelsson",
        "Number": "23",
        "AorC": "          "
    },
    "14188": {
        "Name": "Power",
        "Number": "25",
        "AorC": "          "
    },
    "14189": {
        "Name": "Dahlin",
        "Number": "26",
        "AorC": "C         "
    },
    "14190": {
        "Name": "Malenstyn",
        "Number": "29",
        "AorC": "          "
    },
    "14191": {
        "Name": "Johnson",
        "Number": "33",
        "AorC": "          "
    },
    "14192": {
        "Name": "Lyon",
        "Number": "34",
        "AorC": "          "
    },
    "14193": {
        "Name": "Georgiev",
        "Number": "40",
        "AorC": "          "
    },
    "14194": {
        "Name": "Kozak",
        "Number": "48",
        "AorC": "          "
    },
    "14195": {
        "Name": "Meyer",
        "Number": "49",
        "AorC": "          "
    },
    "14196": {
        "Name": "Geertsen",
        "Number": "55",
        "AorC": "          "
    },
    "14197": {
        "Name": "McLeod",
        "Number": "71",
        "AorC": "          "
    },
    "14198": {
        "Name": "Thompson",
        "Number": "72",
        "AorC": "          "
    },
    "14199": {
        "Name": "Bryson",
        "Number": "78",
        "AorC": "          "
    },
    "14200": {
        "Name": "Tuch",
        "Number": "89",
        "AorC": "          "
    },
    "14201": {
        "Name": "Doan",
        "Number": "91",
        "AorC": "          "
    },
    "14202": {
        "Name": "Matheson",
        "Number": "8",
        "AorC": "          "
    },
    "14203": {
        "Name": "Gallagher",
        "Number": "11",
        "AorC": "          "
    },
    "14204": {
        "Name": "Caufield",
        "Number": "13",
        "AorC": "          "
    },
    "14205": {
        "Name": "Suzuki",
        "Number": "14",
        "AorC": "C         "
    },
    "14206": {
        "Name": "Newhook",
        "Number": "15",
        "AorC": "          "
    },
    "14207": {
        "Name": "Anderson",
        "Number": "17",
        "AorC": "          "
    },
    "14208": {
        "Name": "Slafkovsky",
        "Number": "20",
        "AorC": "          "
    },
    "14209": {
        "Name": "Guhle",
        "Number": "21",
        "AorC": "          "
    },
    "14210": {
        "Name": "Montembeault",
        "Number": "35",
        "AorC": "          "
    },
    "14211": {
        "Name": "Del Gaizo",
        "Number": "37",
        "AorC": "          "
    },
    "14212": {
        "Name": "Clurman",
        "Number": "44",
        "AorC": "          "
    },
    "14213": {
        "Name": "Carrier",
        "Number": "45",
        "AorC": "          "
    },
    "14214": {
        "Name": "Struble",
        "Number": "47",
        "AorC": "          "
    },
    "14215": {
        "Name": "Hutson",
        "Number": "48",
        "AorC": "          "
    },
    "14216": {
        "Name": "Dobson",
        "Number": "53",
        "AorC": "          "
    },
    "14217": {
        "Name": "Farrell",
        "Number": "57",
        "AorC": "          "
    },
    "14218": {
        "Name": "Belzile",
        "Number": "60",
        "AorC": "          "
    },
    "14219": {
        "Name": "Reinbacher",
        "Number": "64",
        "AorC": "          "
    },
    "14220": {
        "Name": "Evans",
        "Number": "71",
        "AorC": "          "
    },
    "14221": {
        "Name": "Xhekaj",
        "Number": "72",
        "AorC": "          "
    },
    "14222": {
        "Name": "Dobes",
        "Number": "75",
        "AorC": "          "
    },
    "14223": {
        "Name": "Bolduc",
        "Number": "76",
        "AorC": "          "
    },
    "14224": {
        "Name": "Dach",
        "Number": "77",
        "AorC": "          "
    },
    "14225": {
        "Name": "Condotta",
        "Number": "82",
        "AorC": "          "
    },
    "14226": {
        "Name": "Trudeau",
        "Number": "84",
        "AorC": "          "
    },
    "14227": {
        "Name": "Veleno",
        "Number": "90",
        "AorC": "          "
    },
    "14228": {
        "Name": "Kapanen",
        "Number": "91",
        "AorC": "          "
    },
    "14229": {
        "Name": "Laine",
        "Number": "92",
        "AorC": "          "
    },
    "14230": {
        "Name": "Demidov",
        "Number": "93",
        "AorC": "          "
    },
    "14231": {
        "Name": "Rohrer",
        "Number": "96",
        "AorC": "          "
    },
    "14232": {
        "Name": "Benoit",
        "Number": "2",
        "AorC": "          "
    },
    "14233": {
        "Name": "Tanev",
        "Number": "8",
        "AorC": "          "
    },
    "14234": {
        "Name": "Domi",
        "Number": "11",
        "AorC": "          "
    },
    "14235": {
        "Name": "Lorentz",
        "Number": "18",
        "AorC": "          "
    },
    "14236": {
        "Name": "Jarnkrok",
        "Number": "19",
        "AorC": "          "
    },
    "14237": {
        "Name": "McCabe",
        "Number": "22",
        "AorC": "          "
    },
    "14238": {
        "Name": "Knies",
        "Number": "23",
        "AorC": "          "
    },
    "14239": {
        "Name": "Laughton",
        "Number": "24",
        "AorC": "          "
    },
    "14240": {
        "Name": "Carlo",
        "Number": "25",
        "AorC": "          "
    },
    "14241": {
        "Name": "Matthews",
        "Number": "34",
        "AorC": "C         "
    },
    "14242": {
        "Name": "Hildeby",
        "Number": "35",
        "AorC": "          "
    },
    "14243": {
        "Name": "Mermis",
        "Number": "36",
        "AorC": "          "
    },
    "14244": {
        "Name": "Danford",
        "Number": "38",
        "AorC": "          "
    },
    "14245": {
        "Name": "Stolarz",
        "Number": "41",
        "AorC": "          "
    },
    "14246": {
        "Name": "Rielly",
        "Number": "44",
        "AorC": "          "
    },
    "14247": {
        "Name": "Reimer",
        "Number": "47",
        "AorC": "          "
    },
    "14248": {
        "Name": "Myers",
        "Number": "51",
        "AorC": "          "
    },
    "14249": {
        "Name": "Cowan",
        "Number": "53",
        "AorC": "          "
    },
    "14250": {
        "Name": "Roy",
        "Number": "55",
        "AorC": "          "
    },
    "14251": {
        "Name": "Woll",
        "Number": "60",
        "AorC": "          "
    },
    "14252": {
        "Name": "Maccelli",
        "Number": "63",
        "AorC": "          "
    },
    "14253": {
        "Name": "McMann",
        "Number": "74",
        "AorC": "          "
    },
    "14254": {
        "Name": "Joshua",
        "Number": "81",
        "AorC": "          "
    },
    "14255": {
        "Name": "Rifai",
        "Number": "83",
        "AorC": "          "
    },
    "14256": {
        "Name": "Nylander",
        "Number": "88",
        "AorC": "          "
    },
    "14257": {
        "Name": "Robertson",
        "Number": "89",
        "AorC": "          "
    },
    "14258": {
        "Name": "Tavares",
        "Number": "91",
        "AorC": "          "
    },
    "14259": {
        "Name": "Ekman-Larsson",
        "Number": "95",
        "AorC": "          "
    },
    "14260": {
        "Name": "Holinka",
        "Number": "98",
        "AorC": "          "
    },
    "14261": {
        "Name": "Christiansen",
        "Number": "2",
        "AorC": "          "
    },
    "14262": {
        "Name": "Coyle",
        "Number": "3",
        "AorC": "          "
    },
    "14263": {
        "Name": "Sillinger",
        "Number": "4",
        "AorC": "          "
    },
    "14264": {
        "Name": "Mateychuk",
        "Number": "5",
        "AorC": "          "
    },
    "14265": {
        "Name": "Werenski",
        "Number": "8",
        "AorC": "          "
    },
    "14266": {
        "Name": "Provorov",
        "Number": "9",
        "AorC": "          "
    },
    "14267": {
        "Name": "Voronkov",
        "Number": "10",
        "AorC": "          "
    },
    "14268": {
        "Name": "Wood",
        "Number": "11",
        "AorC": "          "
    },
    "14269": {
        "Name": "Fabbro",
        "Number": "15",
        "AorC": "          "
    },
    "14270": {
        "Name": "Fantilli",
        "Number": "19",
        "AorC": "          "
    },
    "14271": {
        "Name": "Lundestrom",
        "Number": "21",
        "AorC": "          "
    },
    "14272": {
        "Name": "Dumais",
        "Number": "22",
        "AorC": "          "
    },
    "14273": {
        "Name": "Monahan",
        "Number": "23",
        "AorC": "          "
    },
    "14274": {
        "Name": "Olivier",
        "Number": "24",
        "AorC": "          "
    },
    "14275": {
        "Name": "Aston-Reese",
        "Number": "27",
        "AorC": "          "
    },
    "14276": {
        "Name": "Jenner",
        "Number": "38",
        "AorC": "C         "
    },
    "14277": {
        "Name": "Gudbranson",
        "Number": "44",
        "AorC": "          "
    },
    "14278": {
        "Name": "Marrelli",
        "Number": "54",
        "AorC": "          "
    },
    "14279": {
        "Name": "Chinakhov",
        "Number": "59",
        "AorC": "          "
    },
    "14280": {
        "Name": "Greaves",
        "Number": "73",
        "AorC": "          "
    },
    "14281": {
        "Name": "Severson",
        "Number": "78",
        "AorC": "          "
    },
    "14282": {
        "Name": "Marchenko",
        "Number": "86",
        "AorC": "          "
    },
    "14283": {
        "Name": "Merzlikins",
        "Number": "90",
        "AorC": "          "
    },
    "14284": {
        "Name": "Johnson",
        "Number": "91",
        "AorC": "          "
    },
    "14285": {
        "Name": "Schneider",
        "Number": "4",
        "AorC": "          "
    },
    "14286": {
        "Name": "Miller",
        "Number": "8",
        "AorC": "C         "
    },
    "14287": {
        "Name": "Panarin",
        "Number": "10",
        "AorC": "          "
    },
    "14288": {
        "Name": "Lafreniere",
        "Number": "13",
        "AorC": "          "
    },
    "14289": {
        "Name": "Raddysh",
        "Number": "14",
        "AorC": "          "
    },
    "14290": {
        "Name": "Trocheck",
        "Number": "16",
        "AorC": "          "
    },
    "14291": {
        "Name": "Borgen",
        "Number": "17",
        "AorC": "          "
    },
    "14292": {
        "Name": "Vaakanainen",
        "Number": "18",
        "AorC": "          "
    },
    "14293": {
        "Name": "Brodzinski",
        "Number": "22",
        "AorC": "          "
    },
    "14294": {
        "Name": "Fox",
        "Number": "23",
        "AorC": "          "
    },
    "14295": {
        "Name": "Soucy",
        "Number": "24",
        "AorC": "          "
    },
    "14296": {
        "Name": "Robertson",
        "Number": "29",
        "AorC": "          "
    },
    "14297": {
        "Name": "Shesterkin",
        "Number": "31",
        "AorC": "          "
    },
    "14298": {
        "Name": "Quick",
        "Number": "32",
        "AorC": "          "
    },
    "14299": {
        "Name": "Sustr",
        "Number": "36",
        "AorC": "          "
    },
    "14300": {
        "Name": "Sykora",
        "Number": "38",
        "AorC": "          "
    },
    "14301": {
        "Name": "Carrick",
        "Number": "39",
        "AorC": "          "
    },
    "14302": {
        "Name": "Laba",
        "Number": "42",
        "AorC": "          "
    },
    "14303": {
        "Name": "Sheary",
        "Number": "43",
        "AorC": "          "
    },
    "14304": {
        "Name": "Gavrikov",
        "Number": "44",
        "AorC": "          "
    },
    "14305": {
        "Name": "Chmelar",
        "Number": "49",
        "AorC": "          "
    },
    "14306": {
        "Name": "Cuylle",
        "Number": "50",
        "AorC": "          "
    },
    "14307": {
        "Name": "McCarthy",
        "Number": "53",
        "AorC": "          "
    },
    "14308": {
        "Name": "Berard",
        "Number": "65",
        "AorC": "          "
    },
    "14309": {
        "Name": "Parssinen",
        "Number": "71",
        "AorC": "          "
    },
    "14310": {
        "Name": "Rempe",
        "Number": "73",
        "AorC": "          "
    },
    "14311": {
        "Name": "Dorrington",
        "Number": "83",
        "AorC": "          "
    },
    "14312": {
        "Name": "Edstrom",
        "Number": "84",
        "AorC": "          "
    },
    "14313": {
        "Name": "Zibanejad",
        "Number": "93",
        "AorC": "          "
    },
    "14314": {
        "Name": "Vaisanen",
        "Number": "97",
        "AorC": "          "
    },
    "14315": {
        "Name": "Iorio",
        "Number": "2",
        "AorC": "          "
    },
    "14316": {
        "Name": "Roy",
        "Number": "3",
        "AorC": "          "
    },
    "14317": {
        "Name": "Chychrun",
        "Number": "6",
        "AorC": "          "
    },
    "14318": {
        "Name": "Ovechkin",
        "Number": "8",
        "AorC": "C         "
    },
    "14319": {
        "Name": "Leonard",
        "Number": "9",
        "AorC": "          "
    },
    "14320": {
        "Name": "Milano",
        "Number": "15",
        "AorC": "          "
    },
    "14321": {
        "Name": "Strome",
        "Number": "17",
        "AorC": "          "
    },
    "14322": {
        "Name": "Protas",
        "Number": "21",
        "AorC": "          "
    },
    "14323": {
        "Name": "Duhaime",
        "Number": "22",
        "AorC": "          "
    },
    "14324": {
        "Name": "McMichael",
        "Number": "24",
        "AorC": "          "
    },
    "14325": {
        "Name": "Dowd",
        "Number": "26",
        "AorC": "          "
    },
    "14326": {
        "Name": "Lapierre",
        "Number": "29",
        "AorC": "          "
    },
    "14327": {
        "Name": "Sourdif",
        "Number": "34",
        "AorC": "          "
    },
    "14328": {
        "Name": "Sandin",
        "Number": "38",
        "AorC": "          "
    },
    "14329": {
        "Name": "Fehervary",
        "Number": "42",
        "AorC": "          "
    },
    "14330": {
        "Name": "Wilson",
        "Number": "43",
        "AorC": "          "
    },
    "14331": {
        "Name": "Chisholm",
        "Number": "47",
        "AorC": "          "
    },
    "14332": {
        "Name": "Thompson",
        "Number": "48",
        "AorC": "          "
    },
    "14333": {
        "Name": "Ness",
        "Number": "51",
        "AorC": "          "
    },
    "14334": {
        "Name": "McIlrath",
        "Number": "52",
        "AorC": "          "
    },
    "14335": {
        "Name": "van Riemsdyk",
        "Number": "57",
        "AorC": "          "
    },
    "14336": {
        "Name": "Miroshnichenko",
        "Number": "63",
        "AorC": "          "
    },
    "14337": {
        "Name": "Funk",
        "Number": "71",
        "AorC": "          "
    },
    "14338": {
        "Name": "Beauvillier",
        "Number": "72",
        "AorC": "          "
    },
    "14339": {
        "Name": "Carlson",
        "Number": "74",
        "AorC": "          "
    },
    "14340": {
        "Name": "Lindgren",
        "Number": "79",
        "AorC": "          "
    },
    "14341": {
        "Name": "Dubois",
        "Number": "80",
        "AorC": "          "
    },
    "14342": {
        "Name": "Behrens",
        "Number": "2",
        "AorC": "          "
    },
    "14343": {
        "Name": "MacDonald",
        "Number": "4",
        "AorC": "          "
    },
    "14344": {
        "Name": "Toews",
        "Number": "7",
        "AorC": "          "
    },
    "14345": {
        "Name": "Makar",
        "Number": "8",
        "AorC": "          "
    },
    "14346": {
        "Name": "Nelson",
        "Number": "11",
        "AorC": "          "
    },
    "14347": {
        "Name": "Megna",
        "Number": "12",
        "AorC": "          "
    },
    "14348": {
        "Name": "Nichushkin",
        "Number": "13",
        "AorC": "          "
    },
    "14349": {
        "Name": "Kelly",
        "Number": "17",
        "AorC": "          "
    },
    "14350": {
        "Name": "Drury",
        "Number": "18",
        "AorC": "          "
    },
    "14351": {
        "Name": "Colton",
        "Number": "20",
        "AorC": "          "
    },
    "14352": {
        "Name": "O'Connor",
        "Number": "25",
        "AorC": "          "
    },
    "14353": {
        "Name": "Solovyov",
        "Number": "28",
        "AorC": "          "
    },
    "14354": {
        "Name": "MacKinnon",
        "Number": "29",
        "AorC": "          "
    },
    "14355": {
        "Name": "Blackwood",
        "Number": "39",
        "AorC": "          "
    },
    "14356": {
        "Name": "Wedgewood",
        "Number": "41",
        "AorC": "          "
    },
    "14357": {
        "Name": "Manson",
        "Number": "42",
        "AorC": "          "
    },
    "14358": {
        "Name": "Girard",
        "Number": "49",
        "AorC": "          "
    },
    "14359": {
        "Name": "Miner",
        "Number": "50",
        "AorC": "          "
    },
    "14360": {
        "Name": "Senden",
        "Number": "51",
        "AorC": "          "
    },
    "14361": {
        "Name": "Brindley",
        "Number": "54",
        "AorC": "          "
    },
    "14362": {
        "Name": "Lehkonen",
        "Number": "62",
        "AorC": "          "
    },
    "14363": {
        "Name": "Malinski",
        "Number": "70",
        "AorC": "          "
    },
    "14364": {
        "Name": "Burns",
        "Number": "84",
        "AorC": "          "
    },
    "14365": {
        "Name": "Prishchepov",
        "Number": "85",
        "AorC": "          "
    },
    "14366": {
        "Name": "Necas",
        "Number": "88",
        "AorC": "          "
    },
    "14367": {
        "Name": "Landeskog",
        "Number": "92",
        "AorC": "C         "
    },
    "14368": {
        "Name": "Bardakov",
        "Number": "93",
        "AorC": "          "
    },
    "14369": {
        "Name": "Kiviranta",
        "Number": "94",
        "AorC": "          "
    },
    "14370": {
        "Name": "Olofsson",
        "Number": "95",
        "AorC": "          "
    },
    "14371": {
        "Name": "Forsberg",
        "Number": "9",
        "AorC": "          "
    },
    "14372": {
        "Name": "Jost",
        "Number": "17",
        "AorC": "          "
    },
    "14373": {
        "Name": "Barron",
        "Number": "20",
        "AorC": "          "
    },
    "14374": {
        "Name": "Stastney",
        "Number": "24",
        "AorC": "          "
    },
    "14375": {
        "Name": "Kemell",
        "Number": "25",
        "AorC": "          "
    },
    "14376": {
        "Name": "Annunen",
        "Number": "29",
        "AorC": "          "
    },
    "14377": {
        "Name": "Smith",
        "Number": "36",
        "AorC": "          "
    },
    "14378": {
        "Name": "Blankenburg",
        "Number": "37",
        "AorC": "          "
    },
    "14379": {
        "Name": "Svechkov",
        "Number": "40",
        "AorC": "          "
    },
    "14380": {
        "Name": "Hague",
        "Number": "41",
        "AorC": "          "
    },
    "14381": {
        "Name": "Martin",
        "Number": "44",
        "AorC": "          "
    },
    "14382": {
        "Name": "McCarron",
        "Number": "47",
        "AorC": "          "
    },
    "14383": {
        "Name": "Perbix",
        "Number": "48",
        "AorC": "          "
    },
    "14384": {
        "Name": "Haula",
        "Number": "56",
        "AorC": "          "
    },
    "14385": {
        "Name": "Bunting",
        "Number": "58",
        "AorC": "          "
    },
    "14386": {
        "Name": "Josi",
        "Number": "59",
        "AorC": "C         "
    },
    "14387": {
        "Name": "Wood",
        "Number": "71",
        "AorC": "          "
    },
    "14388": {
        "Name": "Saros",
        "Number": "74",
        "AorC": "          "
    },
    "14389": {
        "Name": "Skjei",
        "Number": "76",
        "AorC": "          "
    },
    "14390": {
        "Name": "Evangelista",
        "Number": "77",
        "AorC": "          "
    },
    "14391": {
        "Name": "Marchessault",
        "Number": "81",
        "AorC": "          "
    },
    "14392": {
        "Name": "Wilsby",
        "Number": "83",
        "AorC": "          "
    },
    "14393": {
        "Name": "Wiesblatt",
        "Number": "89",
        "AorC": "          "
    },
    "14394": {
        "Name": "O'Reilly",
        "Number": "90",
        "AorC": "          "
    },
    "14395": {
        "Name": "Stamkos",
        "Number": "91",
        "AorC": "          "
    },
    "14396": {
        "Name": "Comrie",
        "Number": "1",
        "AorC": "          "
    },
    "14397": {
        "Name": "DeMelo",
        "Number": "2",
        "AorC": "          "
    },
    "14398": {
        "Name": "Pionk",
        "Number": "4",
        "AorC": "          "
    },
    "14399": {
        "Name": "Schenn",
        "Number": "5",
        "AorC": "          "
    },
    "14400": {
        "Name": "Miller",
        "Number": "6",
        "AorC": "          "
    },
    "14401": {
        "Name": "Namestnikov",
        "Number": "7",
        "AorC": "          "
    },
    "14402": {
        "Name": "Iafallo",
        "Number": "9",
        "AorC": "          "
    },
    "14403": {
        "Name": "Vilardi",
        "Number": "13",
        "AorC": "          "
    },
    "14404": {
        "Name": "Nyquist",
        "Number": "14",
        "AorC": "          "
    },
    "14405": {
        "Name": "Lowry",
        "Number": "17",
        "AorC": "C         "
    },
    "14406": {
        "Name": "Toews",
        "Number": "19",
        "AorC": "          "
    },
    "14407": {
        "Name": "Fleury",
        "Number": "24",
        "AorC": "          "
    },
    "14408": {
        "Name": "Ford",
        "Number": "25",
        "AorC": "          "
    },
    "14409": {
        "Name": "Poulter",
        "Number": "30",
        "AorC": "          "
    },
    "14410": {
        "Name": "Barron",
        "Number": "36",
        "AorC": "          "
    },
    "14411": {
        "Name": "Hellebuyck",
        "Number": "37",
        "AorC": "          "
    },
    "14412": {
        "Name": "Gustafsson",
        "Number": "41",
        "AorC": "          "
    },
    "14413": {
        "Name": "Morrissey",
        "Number": "44",
        "AorC": "          "
    },
    "14414": {
        "Name": "Koepke",
        "Number": "45",
        "AorC": "          "
    },
    "14415": {
        "Name": "Zhilkin",
        "Number": "53",
        "AorC": "          "
    },
    "14416": {
        "Name": "Samberg",
        "Number": "54",
        "AorC": "          "
    },
    "14417": {
        "Name": "Scheifele",
        "Number": "55",
        "AorC": "          "
    },
    "14418": {
        "Name": "Wagner",
        "Number": "58",
        "AorC": "          "
    },
    "14419": {
        "Name": "Sautner",
        "Number": "61",
        "AorC": "          "
    },
    "14420": {
        "Name": "Niederreiter",
        "Number": "62",
        "AorC": "          "
    },
    "14421": {
        "Name": "Stanley",
        "Number": "64",
        "AorC": "          "
    },
    "14422": {
        "Name": "Julien",
        "Number": "67",
        "AorC": "          "
    },
    "14423": {
        "Name": "Pearson",
        "Number": "70",
        "AorC": "          "
    },
    "14424": {
        "Name": "Walton",
        "Number": "76",
        "AorC": "          "
    },
    "14425": {
        "Name": "Connor",
        "Number": "81",
        "AorC": "          "
    },
    "14426": {
        "Name": "Anhorn",
        "Number": "83",
        "AorC": "          "
    },
    "14427": {
        "Name": "Barteaux",
        "Number": "86",
        "AorC": "          "
    },
    "14428": {
        "Name": "Di Giuseppe",
        "Number": "89",
        "AorC": "          "
    },
    "14429": {
        "Name": "Chibrikov",
        "Number": "90",
        "AorC": "          "
    },
    "14430": {
        "Name": "Perfetti",
        "Number": "91",
        "AorC": "          "
    },
    "14431": {
        "Name": "Lambert",
        "Number": "93",
        "AorC": "          "
    },
    "14432": {
        "Name": "Cooley",
        "Number": "1",
        "AorC": "          "
    },
    "14433": {
        "Name": "Andersson",
        "Number": "4",
        "AorC": "          "
    },
    "14434": {
        "Name": "Bahl",
        "Number": "7",
        "AorC": "          "
    },
    "14435": {
        "Name": "Huberdeau",
        "Number": "10",
        "AorC": "          "
    },
    "14436": {
        "Name": "Backlund",
        "Number": "11",
        "AorC": "C         "
    },
    "14437": {
        "Name": "Frost",
        "Number": "16",
        "AorC": "          "
    },
    "14438": {
        "Name": "Sharangovich",
        "Number": "17",
        "AorC": "          "
    },
    "14439": {
        "Name": "Coleman",
        "Number": "20",
        "AorC": "          "
    },
    "14440": {
        "Name": "Kirkland",
        "Number": "23",
        "AorC": "          "
    },
    "14441": {
        "Name": "Bean",
        "Number": "24",
        "AorC": "          "
    },
    "14442": {
        "Name": "Coronato",
        "Number": "27",
        "AorC": "          "
    },
    "14443": {
        "Name": "Wolf",
        "Number": "32",
        "AorC": "          "
    },
    "14444": {
        "Name": "Klapka",
        "Number": "43",
        "AorC": "          "
    },
    "14445": {
        "Name": "Hanley",
        "Number": "44",
        "AorC": "          "
    },
    "14446": {
        "Name": "Zary",
        "Number": "47",
        "AorC": "          "
    },
    "14447": {
        "Name": "Gridin",
        "Number": "51",
        "AorC": "          "
    },
    "14448": {
        "Name": "Weegar",
        "Number": "52",
        "AorC": "          "
    },
    "14449": {
        "Name": "Miromanov",
        "Number": "62",
        "AorC": "          "
    },
    "14450": {
        "Name": "Lomberg",
        "Number": "70",
        "AorC": "          "
    },
    "14451": {
        "Name": "Pospisil",
        "Number": "76",
        "AorC": "          "
    },
    "14452": {
        "Name": "Farabee",
        "Number": "86",
        "AorC": "          "
    },
    "14453": {
        "Name": "Parekh",
        "Number": "89",
        "AorC": "          "
    },
    "14454": {
        "Name": "Kadri",
        "Number": "91",
        "AorC": "          "
    },
    "14455": {
        "Name": "Pachal",
        "Number": "94",
        "AorC": "          "
    },
    "14456": {
        "Name": "Smith",
        "Number": "2",
        "AorC": "          "
    },
    "14457": {
        "Name": "Klingberg",
        "Number": "3",
        "AorC": "          "
    },
    "14458": {
        "Name": "Leddy",
        "Number": "4",
        "AorC": "          "
    },
    "14459": {
        "Name": "Desharnais",
        "Number": "5",
        "AorC": "          "
    },
    "14460": {
        "Name": "Dickinson",
        "Number": "6",
        "AorC": "          "
    },
    "14461": {
        "Name": "Orlov",
        "Number": "9",
        "AorC": "          "
    },
    "14462": {
        "Name": "Dellandrea",
        "Number": "10",
        "AorC": "          "
    },
    "14463": {
        "Name": "Afanasyev",
        "Number": "11",
        "AorC": "          "
    },
    "14464": {
        "Name": "Wennberg",
        "Number": "21",
        "AorC": "          "
    },
    "14465": {
        "Name": "Goodrow",
        "Number": "23",
        "AorC": "          "
    },
    "14466": {
        "Name": "Thompson",
        "Number": "26",
        "AorC": "          "
    },
    "14467": {
        "Name": "Askarov",
        "Number": "30",
        "AorC": "          "
    },
    "14468": {
        "Name": "Carlsson",
        "Number": "32",
        "AorC": "          "
    },
    "14469": {
        "Name": "Nedeljkovic",
        "Number": "33",
        "AorC": "          "
    },
    "14470": {
        "Name": "Liljegren",
        "Number": "37",
        "AorC": "          "
    },
    "14471": {
        "Name": "Ferraro",
        "Number": "38",
        "AorC": "          "
    },
    "14472": {
        "Name": "Cagnoni",
        "Number": "42",
        "AorC": "          "
    },
    "14473": {
        "Name": "Graf",
        "Number": "51",
        "AorC": "          "
    },
    "14474": {
        "Name": "Skinner",
        "Number": "53",
        "AorC": "          "
    },
    "14475": {
        "Name": "Cardwell",
        "Number": "56",
        "AorC": "          "
    },
    "14476": {
        "Name": "Ostapchuk",
        "Number": "63",
        "AorC": "          "
    },
    "14477": {
        "Name": "Celebrini",
        "Number": "71",
        "AorC": "          "
    },
    "14478": {
        "Name": "Eklund",
        "Number": "72",
        "AorC": "          "
    },
    "14479": {
        "Name": "Toffoli",
        "Number": "73",
        "AorC": "A         "
    },
    "14480": {
        "Name": "Reaves",
        "Number": "75",
        "AorC": "          "
    },
    "14481": {
        "Name": "Misa",
        "Number": "77",
        "AorC": "          "
    },
    "14482": {
        "Name": "Gaudette",
        "Number": "81",
        "AorC": "          "
    },
    "14483": {
        "Name": "Villeneuve-Houle",
        "Number": "83",
        "AorC": "          "
    },
    "14484": {
        "Name": "Mukhamadullin",
        "Number": "85",
        "AorC": "          "
    },
    "14485": {
        "Name": "Kurashev",
        "Number": "96",
        "AorC": "          "
    },
    "14486": {
        "Name": "Chiarot",
        "Number": "8",
        "AorC": "          "
    },
    "14487": {
        "Name": "Copp",
        "Number": "18",
        "AorC": "          "
    },
    "14488": {
        "Name": "Johansson",
        "Number": "20",
        "AorC": "          "
    },
    "14489": {
        "Name": "van Riemsdyk",
        "Number": "21",
        "AorC": "          "
    },
    "14490": {
        "Name": "Appleton",
        "Number": "22",
        "AorC": "          "
    },
    "14491": {
        "Name": "Buium",
        "Number": "22",
        "AorC": "          "
    },
    "14492": {
        "Name": "Hamonic",
        "Number": "23",
        "AorC": "          "
    },
    "14493": {
        "Name": "Raymond",
        "Number": "23",
        "AorC": "          "
    },
    "14494": {
        "Name": "Bernard-Docker",
        "Number": "25",
        "AorC": "          "
    },
    "14495": {
        "Name": "Rasmussen",
        "Number": "27",
        "AorC": "          "
    },
    "14496": {
        "Name": "Brandsegg-Nygard",
        "Number": "28",
        "AorC": "          "
    },
    "14497": {
        "Name": "Danielson",
        "Number": "29",
        "AorC": "          "
    },
    "14498": {
        "Name": "Gibson",
        "Number": "36",
        "AorC": "          "
    },
    "14499": {
        "Name": "Compher",
        "Number": "37",
        "AorC": "          "
    },
    "14500": {
        "Name": "Talbot",
        "Number": "39",
        "AorC": "          "
    },
    "14501": {
        "Name": "Sandin-Pellikka",
        "Number": "44",
        "AorC": "          "
    },
    "14502": {
        "Name": "Berggren",
        "Number": "48",
        "AorC": "          "
    },
    "14503": {
        "Name": "Seider",
        "Number": "53",
        "AorC": "          "
    },
    "14504": {
        "Name": "Finnie",
        "Number": "58",
        "AorC": "          "
    },
    "14505": {
        "Name": "Larkin",
        "Number": "71",
        "AorC": "C         "
    },
    "14506": {
        "Name": "Edvinsson",
        "Number": "77",
        "AorC": "          "
    },
    "14507": {
        "Name": "Soderblom",
        "Number": "85",
        "AorC": "          "
    },
    "14508": {
        "Name": "Kane",
        "Number": "88",
        "AorC": "          "
    },
    "14509": {
        "Name": "Kasper",
        "Number": "92",
        "AorC": "          "
    },
    "14510": {
        "Name": "DeBrincat",
        "Number": "93",
        "AorC": "          "
    },
    "14511": {
        "Name": "Merilainen",
        "Number": "1",
        "AorC": "          "
    },
    "14512": {
        "Name": "Zub",
        "Number": "2",
        "AorC": "          "
    },
    "14513": {
        "Name": "Jensen",
        "Number": "3",
        "AorC": "          "
    },
    "14514": {
        "Name": "Tkachuk",
        "Number": "7",
        "AorC": "C         "
    },
    "14515": {
        "Name": "Spence",
        "Number": "10",
        "AorC": "          "
    },
    "14516": {
        "Name": "Pinto",
        "Number": "12",
        "AorC": "          "
    },
    "14517": {
        "Name": "Stutzle",
        "Number": "18",
        "AorC": "          "
    },
    "14518": {
        "Name": "Batherson",
        "Number": "19",
        "AorC": "          "
    },
    "14519": {
        "Name": "Ellinas",
        "Number": "19",
        "AorC": "          "
    },
    "14520": {
        "Name": "Zetterlund",
        "Number": "20",
        "AorC": "          "
    },
    "14521": {
        "Name": "Cousins",
        "Number": "21",
        "AorC": "          "
    },
    "14522": {
        "Name": "Amadio",
        "Number": "22",
        "AorC": "          "
    },
    "14523": {
        "Name": "MacDermid",
        "Number": "23",
        "AorC": "          "
    },
    "14524": {
        "Name": "Cozens",
        "Number": "24",
        "AorC": "          "
    },
    "14525": {
        "Name": "Giroux",
        "Number": "28",
        "AorC": "          "
    },
    "14526": {
        "Name": "Matinpalo",
        "Number": "33",
        "AorC": "          "
    },
    "14527": {
        "Name": "Ullmark",
        "Number": "35",
        "AorC": "          "
    },
    "14528": {
        "Name": "Sebrango",
        "Number": "37",
        "AorC": "          "
    },
    "14529": {
        "Name": "Kleven",
        "Number": "43",
        "AorC": "          "
    },
    "14530": {
        "Name": "Perron",
        "Number": "57",
        "AorC": "          "
    },
    "14531": {
        "Name": "Yakemchuk",
        "Number": "58",
        "AorC": "          "
    },
    "14532": {
        "Name": "Greig",
        "Number": "71",
        "AorC": "          "
    },
    "14533": {
        "Name": "Chabot",
        "Number": "72",
        "AorC": "          "
    },
    "14534": {
        "Name": "Sanderson",
        "Number": "85",
        "AorC": "          "
    },
    "14535": {
        "Name": "Eller",
        "Number": "89",
        "AorC": "          "
    },
    "14536": {
        "Name": "Dillon",
        "Number": "5",
        "AorC": "          "
    },
    "14537": {
        "Name": "Hamilton",
        "Number": "7",
        "AorC": "          "
    },
    "14538": {
        "Name": "Kovacevic",
        "Number": "8",
        "AorC": "          "
    },
    "14539": {
        "Name": "Rooney",
        "Number": "10",
        "AorC": "          "
    },
    "14540": {
        "Name": "Noesen",
        "Number": "11",
        "AorC": "          "
    },
    "14541": {
        "Name": "Glass",
        "Number": "12",
        "AorC": "          "
    },
    "14542": {
        "Name": "Hischier",
        "Number": "13",
        "AorC": "C         "
    },
    "14543": {
        "Name": "Glendening",
        "Number": "14",
        "AorC": "          "
    },
    "14544": {
        "Name": "Brown",
        "Number": "16",
        "AorC": "          "
    },
    "14545": {
        "Name": "Nemec",
        "Number": "17",
        "AorC": "          "
    },
    "14546": {
        "Name": "Palat",
        "Number": "18",
        "AorC": "          "
    },
    "14547": {
        "Name": "Lachance",
        "Number": "20",
        "AorC": "          "
    },
    "14548": {
        "Name": "McLaughlin",
        "Number": "21",
        "AorC": "          "
    },
    "14549": {
        "Name": "Pesce",
        "Number": "22",
        "AorC": "          "
    },
    "14550": {
        "Name": "Casey",
        "Number": "24",
        "AorC": "          "
    },
    "14551": {
        "Name": "Markstrom",
        "Number": "25",
        "AorC": "          "
    },
    "14552": {
        "Name": "Meier",
        "Number": "28",
        "AorC": "          "
    },
    "14553": {
        "Name": "Hameenaho",
        "Number": "29",
        "AorC": "          "
    },
    "14554": {
        "Name": "Dadonov",
        "Number": "33",
        "AorC": "          "
    },
    "14555": {
        "Name": "Allen",
        "Number": "34",
        "AorC": "          "
    },
    "14556": {
        "Name": "Hughes",
        "Number": "43",
        "AorC": "          "
    },
    "14557": {
        "Name": "Cholowski",
        "Number": "44",
        "AorC": "          "
    },
    "14558": {
        "Name": "Cotter",
        "Number": "47",
        "AorC": "          "
    },
    "14559": {
        "Name": "Bratt",
        "Number": "63",
        "AorC": "          "
    },
    "14560": {
        "Name": "Siegenthaler",
        "Number": "71",
        "AorC": "          "
    },
    "14561": {
        "Name": "Gritsyuk",
        "Number": "81",
        "AorC": "          "
    },
    "14562": {
        "Name": "Lammikko",
        "Number": "83",
        "AorC": "          "
    },
    "14563": {
        "Name": "Hughes",
        "Number": "86",
        "AorC": "          "
    },
    "14564": {
        "Name": "Mercer",
        "Number": "91",
        "AorC": "          "
    },
    "14565": {
        "Name": "Zamula",
        "Number": "5",
        "AorC": "          "
    },
    "14566": {
        "Name": "Sanheim",
        "Number": "6",
        "AorC": "          "
    },
    "14567": {
        "Name": "York",
        "Number": "8",
        "AorC": "          "
    },
    "14568": {
        "Name": "Drysdale",
        "Number": "9",
        "AorC": "          "
    },
    "14569": {
        "Name": "Brink",
        "Number": "10",
        "AorC": "          "
    },
    "14570": {
        "Name": "Konecny",
        "Number": "11",
        "AorC": "          "
    },
    "14571": {
        "Name": "Ginning",
        "Number": "13",
        "AorC": "          "
    },
    "14572": {
        "Name": "Couturier",
        "Number": "14",
        "AorC": "C         "
    },
    "14573": {
        "Name": "Luchanko",
        "Number": "17",
        "AorC": "          "
    },
    "14574": {
        "Name": "Abols",
        "Number": "18",
        "AorC": "          "
    },
    "14575": {
        "Name": "Hathaway",
        "Number": "19",
        "AorC": "          "
    },
    "14576": {
        "Name": "Dvorak",
        "Number": "22",
        "AorC": "          "
    },
    "14577": {
        "Name": "Seeler",
        "Number": "24",
        "AorC": "          "
    },
    "14578": {
        "Name": "Cates",
        "Number": "27",
        "AorC": "          "
    },
    "14579": {
        "Name": "Grebenkin",
        "Number": "29",
        "AorC": "          "
    },
    "14580": {
        "Name": "Ersson",
        "Number": "33",
        "AorC": "          "
    },
    "14581": {
        "Name": "Michkov",
        "Number": "39",
        "AorC": "          "
    },
    "14582": {
        "Name": "Deslauriers",
        "Number": "44",
        "AorC": "          "
    },
    "14583": {
        "Name": "Zegras",
        "Number": "46",
        "AorC": "          "
    },
    "14584": {
        "Name": "Juulsen",
        "Number": "47",
        "AorC": "          "
    },
    "14585": {
        "Name": "Ristolainen",
        "Number": "55",
        "AorC": "          "
    },
    "14586": {
        "Name": "Bonk",
        "Number": "59",
        "AorC": "          "
    },
    "14587": {
        "Name": "Foerster",
        "Number": "71",
        "AorC": "          "
    },
    "14588": {
        "Name": "Tippett",
        "Number": "74",
        "AorC": "          "
    },
    "14589": {
        "Name": "Samson",
        "Number": "75",
        "AorC": "          "
    },
    "14590": {
        "Name": "Vladar",
        "Number": "80",
        "AorC": "          "
    },
    "14591": {
        "Name": "DeSmith",
        "Number": "1",
        "AorC": "          "
    },
    "14592": {
        "Name": "Heiskanen",
        "Number": "4",
        "AorC": "          "
    },
    "14593": {
        "Name": "Lundkvist",
        "Number": "5",
        "AorC": "          "
    },
    "14594": {
        "Name": "Bichsel",
        "Number": "6",
        "AorC": "          "
    },
    "14595": {
        "Name": "Back",
        "Number": "10",
        "AorC": "          "
    },
    "14596": {
        "Name": "Bastian",
        "Number": "11",
        "AorC": "          "
    },
    "14597": {
        "Name": "Faksa",
        "Number": "12",
        "AorC": "          "
    },
    "14598": {
        "Name": "Benn",
        "Number": "14",
        "AorC": "C         "
    },
    "14599": {
        "Name": "Blackwell",
        "Number": "15",
        "AorC": "          "
    },
    "14600": {
        "Name": "Steel",
        "Number": "18",
        "AorC": "          "
    },
    "14601": {
        "Name": "Robertson",
        "Number": "21",
        "AorC": "          "
    },
    "14602": {
        "Name": "Bourque",
        "Number": "22",
        "AorC": "          "
    },
    "14603": {
        "Name": "Lindell",
        "Number": "23",
        "AorC": "          "
    },
    "14604": {
        "Name": "Hintz",
        "Number": "24",
        "AorC": "          "
    },
    "14605": {
        "Name": "Petrovic",
        "Number": "28",
        "AorC": "          "
    },
    "14606": {
        "Name": "Oettinger",
        "Number": "29",
        "AorC": "          "
    },
    "14607": {
        "Name": "Krys",
        "Number": "36",
        "AorC": "          "
    },
    "14608": {
        "Name": "McDonald",
        "Number": "40",
        "AorC": "          "
    },
    "14609": {
        "Name": "Lyubushkin",
        "Number": "46",
        "AorC": "          "
    },
    "14610": {
        "Name": "Wheatcroft",
        "Number": "48",
        "AorC": "          "
    },
    "14611": {
        "Name": "Johnston",
        "Number": "53",
        "AorC": "          "
    },
    "14612": {
        "Name": "Harley",
        "Number": "55",
        "AorC": "          "
    },
    "14613": {
        "Name": "Erne",
        "Number": "76",
        "AorC": "          "
    },
    "14614": {
        "Name": "Seguin",
        "Number": "91",
        "AorC": "          "
    },
    "14615": {
        "Name": "Duchene",
        "Number": "95",
        "AorC": "          "
    },
    "14616": {
        "Name": "Rantanen",
        "Number": "96",
        "AorC": "          "
    },
    "14617": {
        "Name": "Broberg",
        "Number": "6",
        "AorC": "          "
    },
    "14618": {
        "Name": "Texier",
        "Number": "9",
        "AorC": "          "
    },
    "14619": {
        "Name": "Schenn",
        "Number": "10",
        "AorC": "C         "
    },
    "14620": {
        "Name": "Lucic",
        "Number": "12",
        "AorC": "          "
    },
    "14621": {
        "Name": "Toropchenko",
        "Number": "13",
        "AorC": "          "
    },
    "14622": {
        "Name": "Fowler",
        "Number": "17",
        "AorC": "          "
    },
    "14623": {
        "Name": "Thomas",
        "Number": "18",
        "AorC": "          "
    },
    "14624": {
        "Name": "Snuggerud",
        "Number": "21",
        "AorC": "          "
    },
    "14625": {
        "Name": "Suter",
        "Number": "22",
        "AorC": "          "
    },
    "14626": {
        "Name": "Mailloux",
        "Number": "23",
        "AorC": "          "
    },
    "14627": {
        "Name": "Kyrou",
        "Number": "25",
        "AorC": "          "
    },
    "14628": {
        "Name": "Walker",
        "Number": "26",
        "AorC": "          "
    },
    "14629": {
        "Name": "Hofer",
        "Number": "30",
        "AorC": "          "
    },
    "14630": {
        "Name": "Koprowski",
        "Number": "45",
        "AorC": "          "
    },
    "14631": {
        "Name": "Krug",
        "Number": "47",
        "AorC": "          "
    },
    "14632": {
        "Name": "Binnington",
        "Number": "50",
        "AorC": "          "
    },
    "14633": {
        "Name": "Kessel",
        "Number": "51",
        "AorC": "          "
    },
    "14634": {
        "Name": "Dean",
        "Number": "52",
        "AorC": "          "
    },
    "14635": {
        "Name": "Parayko",
        "Number": "55",
        "AorC": "          "
    },
    "14636": {
        "Name": "Neighbours",
        "Number": "63",
        "AorC": "          "
    },
    "14637": {
        "Name": "Sundqvist",
        "Number": "70",
        "AorC": "          "
    },
    "14638": {
        "Name": "Joseph",
        "Number": "71",
        "AorC": "          "
    },
    "14639": {
        "Name": "Faulk",
        "Number": "72",
        "AorC": "          "
    },
    "14640": {
        "Name": "Tucker",
        "Number": "75",
        "AorC": "          "
    },
    "14641": {
        "Name": "Bjugstad",
        "Number": "77",
        "AorC": "          "
    },
    "14642": {
        "Name": "Holloway",
        "Number": "81",
        "AorC": "          "
    },
    "14643": {
        "Name": "Mrsic",
        "Number": "86",
        "AorC": "          "
    },
    "14644": {
        "Name": "McIsaac",
        "Number": "87",
        "AorC": "          "
    },
    "14645": {
        "Name": "Buchnevich",
        "Number": "89",
        "AorC": "          "
    },
    "14646": {
        "Name": "Mayich",
        "Number": "95",
        "AorC": "          "
    },
    "14647": {
        "Name": "Bouchard",
        "Number": "2",
        "AorC": "          "
    },
    "14648": {
        "Name": "Frederic",
        "Number": "10",
        "AorC": "          "
    },
    "14649": {
        "Name": "Janmark",
        "Number": "13",
        "AorC": "          "
    },
    "14650": {
        "Name": "Ekholm",
        "Number": "14",
        "AorC": "          "
    },
    "14651": {
        "Name": "Hyman",
        "Number": "18",
        "AorC": "          "
    },
    "14652": {
        "Name": "Henrique",
        "Number": "19",
        "AorC": "          "
    },
    "14653": {
        "Name": "Lazar",
        "Number": "20",
        "AorC": "          "
    },
    "14654": {
        "Name": "Savoie",
        "Number": "22",
        "AorC": "          "
    },
    "14655": {
        "Name": "Nurse",
        "Number": "25",
        "AorC": "          "
    },
    "14656": {
        "Name": "Kulak",
        "Number": "27",
        "AorC": "          "
    },
    "14657": {
        "Name": "Draisaitl",
        "Number": "29",
        "AorC": "          "
    },
    "14658": {
        "Name": "Pickard",
        "Number": "30",
        "AorC": "          "
    },
    "14659": {
        "Name": "Ungar",
        "Number": "32",
        "AorC": "          "
    },
    "14660": {
        "Name": "Leppänen",
        "Number": "37",
        "AorC": "          "
    },
    "14661": {
        "Name": "Kapanen",
        "Number": "42",
        "AorC": "          "
    },
    "14662": {
        "Name": "Philp",
        "Number": "48",
        "AorC": "          "
    },
    "14663": {
        "Name": "Emberson",
        "Number": "49",
        "AorC": "          "
    },
    "14664": {
        "Name": "Stecher",
        "Number": "51",
        "AorC": "          "
    },
    "14665": {
        "Name": "Howard",
        "Number": "53",
        "AorC": "          "
    },
    "14666": {
        "Name": "Nicholl",
        "Number": "56",
        "AorC": "          "
    },
    "14667": {
        "Name": "Carfagna",
        "Number": "73",
        "AorC": "          "
    },
    "14668": {
        "Name": "Skinner",
        "Number": "74",
        "AorC": "          "
    },
    "14669": {
        "Name": "Regula",
        "Number": "75",
        "AorC": "          "
    },
    "14670": {
        "Name": "Tomasek",
        "Number": "86",
        "AorC": "          "
    },
    "14671": {
        "Name": "Mangiapane",
        "Number": "88",
        "AorC": "          "
    },
    "14672": {
        "Name": "Podkolzin",
        "Number": "92",
        "AorC": "          "
    },
    "14673": {
        "Name": "Nugent-Hopkins",
        "Number": "93",
        "AorC": "          "
    },
    "14674": {
        "Name": "Walman",
        "Number": "96",
        "AorC": "          "
    },
    "14675": {
        "Name": "McDavid",
        "Number": "97",
        "AorC": "C         "
    },
    "14676": {
        "Name": "Larsson",
        "Number": "6",
        "AorC": "          "
    },
    "14677": {
        "Name": "Eberle",
        "Number": "7",
        "AorC": "C         "
    },
    "14678": {
        "Name": "Fleury",
        "Number": "8",
        "AorC": "          "
    },
    "14679": {
        "Name": "Stephenson",
        "Number": "9",
        "AorC": "          "
    },
    "14680": {
        "Name": "Beniers",
        "Number": "10",
        "AorC": "          "
    },
    "14681": {
        "Name": "Kartye",
        "Number": "12",
        "AorC": "          "
    },
    "14682": {
        "Name": "Schwartz",
        "Number": "17",
        "AorC": "          "
    },
    "14683": {
        "Name": "McCann",
        "Number": "19",
        "AorC": "          "
    },
    "14684": {
        "Name": "Tolvanen",
        "Number": "20",
        "AorC": "          "
    },
    "14685": {
        "Name": "Oleksiak",
        "Number": "24",
        "AorC": "          "
    },
    "14686": {
        "Name": "Winterton",
        "Number": "26",
        "AorC": "          "
    },
    "14687": {
        "Name": "Marchment",
        "Number": "27",
        "AorC": "          "
    },
    "14688": {
        "Name": "Mahura",
        "Number": "28",
        "AorC": "          "
    },
    "14689": {
        "Name": "Dunn",
        "Number": "29",
        "AorC": "          "
    },
    "14690": {
        "Name": "Murray",
        "Number": "30",
        "AorC": "          "
    },
    "14691": {
        "Name": "Grubauer",
        "Number": "31",
        "AorC": "          "
    },
    "14692": {
        "Name": "Daccord",
        "Number": "35",
        "AorC": "          "
    },
    "14693": {
        "Name": "Nyman",
        "Number": "38",
        "AorC": "          "
    },
    "14694": {
        "Name": "Evans",
        "Number": "41",
        "AorC": "          "
    },
    "14695": {
        "Name": "Wright",
        "Number": "51",
        "AorC": "          "
    },
    "14696": {
        "Name": "Lindgren",
        "Number": "55",
        "AorC": "          "
    },
    "14697": {
        "Name": "Montour",
        "Number": "62",
        "AorC": "          "
    },
    "14698": {
        "Name": "Catton",
        "Number": "77",
        "AorC": "          "
    },
    "14699": {
        "Name": "Kakko",
        "Number": "84",
        "AorC": "          "
    },
    "14700": {
        "Name": "Gaudreau",
        "Number": "89",
        "AorC": "          "
    },
    "14701": {
        "Name": "McCormick",
        "Number": "91",
        "AorC": "          "
    },
    "14718": {
        "Name": "CONNER",
        "Number": "41",
        "AorC": "          "
    },
    "14719": {
        "Name": "KANE",
        "Number": "88",
        "AorC": "A         "
    },
    "14720": {
        "Name": "Abate",
        "Number": "53",
        "AorC": "          "
    },
    "14721": {
        "Name": "Aspirot",
        "Number": "45",
        "AorC": "          "
    },
    "14722": {
        "Name": "Biasca",
        "Number": "71",
        "AorC": "          "
    },
    "14723": {
        "Name": "Borgen",
        "Number": "17",
        "AorC": "          "
    },
    "14724": {
        "Name": "Brunet",
        "Number": "42",
        "AorC": "          "
    },
    "14725": {
        "Name": "Clifton",
        "Number": "17",
        "AorC": "          "
    },
    "14726": {
        "Name": "DiPietro",
        "Number": "30",
        "AorC": "          "
    },
    "14727": {
        "Name": "Duran",
        "Number": "62",
        "AorC": "          "
    },
    "14728": {
        "Name": "Eyssimont",
        "Number": "81",
        "AorC": "          "
    },
    "14729": {
        "Name": "Geekie",
        "Number": "39",
        "AorC": "          "
    },
    "14730": {
        "Name": "Hagens",
        "Number": "44",
        "AorC": "          "
    },
    "14731": {
        "Name": "Jeannot",
        "Number": "84",
        "AorC": "          "
    },
    "14732": {
        "Name": "Jokiharju",
        "Number": "20",
        "AorC": "          "
    },
    "14733": {
        "Name": "Kastelic",
        "Number": "47",
        "AorC": "          "
    },
    "14734": {
        "Name": "Khusnutdinov",
        "Number": "92",
        "AorC": "          "
    },
    "14735": {
        "Name": "Kuraly",
        "Number": "52",
        "AorC": "          "
    },
    "14736": {
        "Name": "Lindholm",
        "Number": "27",
        "AorC": "          "
    },
    "14737": {
        "Name": "Lindholm",
        "Number": "28",
        "AorC": "          "
    },
    "14738": {
        "Name": "Lohrei",
        "Number": "6",
        "AorC": "          "
    },
    "14739": {
        "Name": "McAvoy",
        "Number": "73",
        "AorC": "          "
    },
    "14740": {
        "Name": "Minten",
        "Number": "93",
        "AorC": "          "
    },
    "14741": {
        "Name": "Mittelstadt",
        "Number": "11",
        "AorC": "          "
    },
    "14742": {
        "Name": "Pastrnak",
        "Number": "88",
        "AorC": "C         "
    },
    "14743": {
        "Name": "Peterka",
        "Number": "10",
        "AorC": "          "
    },
    "14744": {
        "Name": "Poitras",
        "Number": "51",
        "AorC": "          "
    },
    "14745": {
        "Name": "Schmaltz",
        "Number": "82",
        "AorC": "          "
    },
    "14746": {
        "Name": "Swayman",
        "Number": "1",
        "AorC": "          "
    },
    "14747": {
        "Name": "Zacha",
        "Number": "18",
        "AorC": "          "
    },
    "14748": {
        "Name": "Zadorov",
        "Number": "91",
        "AorC": "          "
    },
    "14749": {
        "Name": "Luukkonen",
        "Number": "1",
        "AorC": "          "
    },
    "14750": {
        "Name": "Benson",
        "Number": "6",
        "AorC": "          "
    },
    "14751": {
        "Name": "Norris",
        "Number": "9",
        "AorC": "          "
    },
    "14752": {
        "Name": "Carrick",
        "Number": "10",
        "AorC": "          "
    },
    "14753": {
        "Name": "Danforth",
        "Number": "15",
        "AorC": "          "
    },
    "14754": {
        "Name": "Zucker",
        "Number": "17",
        "AorC": "          "
    },
    "14755": {
        "Name": "Krebs",
        "Number": "19",
        "AorC": "          "
    },
    "14756": {
        "Name": "Kulich",
        "Number": "20",
        "AorC": "          "
    },
    "14757": {
        "Name": "Timmins",
        "Number": "21",
        "AorC": "          "
    },
    "14758": {
        "Name": "Quinn",
        "Number": "22",
        "AorC": "          "
    },
    "14759": {
        "Name": "Samuelsson",
        "Number": "23",
        "AorC": "          "
    },
    "14760": {
        "Name": "Power",
        "Number": "25",
        "AorC": "          "
    },
    "14761": {
        "Name": "Dahlin",
        "Number": "26",
        "AorC": "C         "
    },
    "14762": {
        "Name": "Malenstyn",
        "Number": "29",
        "AorC": "          "
    },
    "14763": {
        "Name": "Villalta",
        "Number": "31",
        "AorC": "          "
    },
    "14764": {
        "Name": "Lyon",
        "Number": "34",
        "AorC": "          "
    },
    "14765": {
        "Name": "Crevier",
        "Number": "46",
        "AorC": "          "
    },
    "14766": {
        "Name": "Kozak",
        "Number": "48",
        "AorC": "          "
    },
    "14767": {
        "Name": "Stanley",
        "Number": "64",
        "AorC": "          "
    },
    "14768": {
        "Name": "Pearson",
        "Number": "70",
        "AorC": "          "
    },
    "14769": {
        "Name": "McLeod",
        "Number": "71",
        "AorC": "          "
    },
    "14770": {
        "Name": "Thompson",
        "Number": "72",
        "AorC": "A         "
    },
    "14771": {
        "Name": "Metsa",
        "Number": "73",
        "AorC": "          "
    },
    "14772": {
        "Name": "Ostlund",
        "Number": "86",
        "AorC": "          "
    },
    "14773": {
        "Name": "Doan",
        "Number": "91",
        "AorC": "          "
    },
    "14774": {
        "Name": "Ellis",
        "Number": "92",
        "AorC": "          "
    },
    "14775": {
        "Name": "Helenius",
        "Number": "94",
        "AorC": "          "
    },
    "14776": {
        "Name": "Cooley",
        "Number": "1",
        "AorC": "          "
    },
    "14777": {
        "Name": "Bahl",
        "Number": "7",
        "AorC": "          "
    },
    "14778": {
        "Name": "Backlund",
        "Number": "11",
        "AorC": "C         "
    },
    "14779": {
        "Name": "Frost",
        "Number": "16",
        "AorC": "          "
    },
    "14780": {
        "Name": "Sharangovich",
        "Number": "17",
        "AorC": "          "
    },
    "14781": {
        "Name": "Parekh",
        "Number": "19",
        "AorC": "          "
    },
    "14782": {
        "Name": "Strome",
        "Number": "22",
        "AorC": "          "
    },
    "14783": {
        "Name": "Bean",
        "Number": "24",
        "AorC": "          "
    },
    "14784": {
        "Name": "Coronato",
        "Number": "27",
        "AorC": "          "
    },
    "14785": {
        "Name": "Whitecloud",
        "Number": "28",
        "AorC": "          "
    },
    "14786": {
        "Name": "Honzek",
        "Number": "29",
        "AorC": "          "
    },
    "14787": {
        "Name": "Wolf",
        "Number": "32",
        "AorC": "          "
    },
    "14788": {
        "Name": "Kuznetsov",
        "Number": "37",
        "AorC": "          "
    },
    "14789": {
        "Name": "Gross",
        "Number": "39",
        "AorC": "          "
    },
    "14790": {
        "Name": "Klapka",
        "Number": "43",
        "AorC": "          "
    },
    "14791": {
        "Name": "Hanley",
        "Number": "44",
        "AorC": "          "
    },
    "14792": {
        "Name": "Zary",
        "Number": "47",
        "AorC": "          "
    },
    "14793": {
        "Name": "Brzustewicz",
        "Number": "48",
        "AorC": "          "
    },
    "14794": {
        "Name": "Wiebe",
        "Number": "52",
        "AorC": "          "
    },
    "14795": {
        "Name": "Jones",
        "Number": "64",
        "AorC": "          "
    },
    "14796": {
        "Name": "Pospisil",
        "Number": "76",
        "AorC": "          "
    },
    "14797": {
        "Name": "Farabee",
        "Number": "86",
        "AorC": "          "
    },
    "14798": {
        "Name": "Gridin",
        "Number": "92",
        "AorC": "          "
    },
    "14799": {
        "Name": "Pachal",
        "Number": "94",
        "AorC": "          "
    },
    "14800": {
        "Name": "Gostisbehere",
        "Number": "4",
        "AorC": "          "
    },
    "14801": {
        "Name": "Chatfield",
        "Number": "5",
        "AorC": "          "
    },
    "14802": {
        "Name": "Reilly",
        "Number": "6",
        "AorC": "          "
    },
    "14803": {
        "Name": "Staal",
        "Number": "11",
        "AorC": "C         "
    },
    "14804": {
        "Name": "Miller",
        "Number": "19",
        "AorC": "          "
    },
    "14805": {
        "Name": "Aho",
        "Number": "20",
        "AorC": "          "
    },
    "14806": {
        "Name": "Nikishin",
        "Number": "21",
        "AorC": "          "
    },
    "14807": {
        "Name": "Stankoven",
        "Number": "22",
        "AorC": "          "
    },
    "14808": {
        "Name": "Jarvis",
        "Number": "24",
        "AorC": "          "
    },
    "14809": {
        "Name": "Walker",
        "Number": "26",
        "AorC": "          "
    },
    "14810": {
        "Name": "Ehlers",
        "Number": "27",
        "AorC": "          "
    },
    "14811": {
        "Name": "Carrier",
        "Number": "28",
        "AorC": "          "
    },
    "14812": {
        "Name": "Bussi",
        "Number": "32",
        "AorC": "          "
    },
    "14813": {
        "Name": "Svechnikov",
        "Number": "37",
        "AorC": "          "
    },
    "14814": {
        "Name": "Deslauriers",
        "Number": "44",
        "AorC": "          "
    },
    "14815": {
        "Name": "Martinook",
        "Number": "48",
        "AorC": "          "
    },
    "14816": {
        "Name": "Robinson",
        "Number": "50",
        "AorC": "          "
    },
    "14817": {
        "Name": "Kochetkov",
        "Number": "52",
        "AorC": "          "
    },
    "14818": {
        "Name": "Blake",
        "Number": "53",
        "AorC": "          "
    },
    "14819": {
        "Name": "Hall",
        "Number": "71",
        "AorC": "          "
    },
    "14820": {
        "Name": "Slavin",
        "Number": "74",
        "AorC": "          "
    },
    "14821": {
        "Name": "Jankowski",
        "Number": "77",
        "AorC": "          "
    },
    "14822": {
        "Name": "Lansard",
        "Number": "81",
        "AorC": "          "
    },
    "14823": {
        "Name": "Kotkaniemi",
        "Number": "82",
        "AorC": "          "
    },
    "14824": {
        "Name": "Rinzel",
        "Number": "6",
        "AorC": "          "
    },
    "14825": {
        "Name": "Donato",
        "Number": "8",
        "AorC": "          "
    },
    "14826": {
        "Name": "Moore",
        "Number": "11",
        "AorC": "          "
    },
    "14827": {
        "Name": "Boisvert",
        "Number": "12",
        "AorC": "          "
    },
    "14828": {
        "Name": "Greenway",
        "Number": "12",
        "AorC": "          "
    },
    "14829": {
        "Name": "Korchinski",
        "Number": "14",
        "AorC": "          "
    },
    "14830": {
        "Name": "Frondell",
        "Number": "16",
        "AorC": "          "
    },
    "14831": {
        "Name": "Greene",
        "Number": "20",
        "AorC": "          "
    },
    "14832": {
        "Name": "Byram",
        "Number": "24",
        "AorC": "          "
    },
    "14833": {
        "Name": "Toninato",
        "Number": "25",
        "AorC": "          "
    },
    "14834": {
        "Name": "Mangiapane",
        "Number": "26",
        "AorC": "          "
    },
    "14835": {
        "Name": "Knight",
        "Number": "30",
        "AorC": "          "
    },
    "14836": {
        "Name": "delMastro",
        "Number": "38",
        "AorC": "          "
    },
    "14837": {
        "Name": "Soderblom",
        "Number": "40",
        "AorC": "          "
    },
    "14838": {
        "Name": "Kaiser",
        "Number": "44",
        "AorC": "          "
    },
    "14839": {
        "Name": "Levshunov",
        "Number": "55",
        "AorC": "          "
    },
    "14840": {
        "Name": "Bertuzzi",
        "Number": "59",
        "AorC": "          "
    },
    "14841": {
        "Name": "Vlasic",
        "Number": "72",
        "AorC": "          "
    },
    "14842": {
        "Name": "Lardis",
        "Number": "76",
        "AorC": "          "
    },
    "14843": {
        "Name": "Slaggert",
        "Number": "84",
        "AorC": "          "
    },
    "14844": {
        "Name": "Teravainen",
        "Number": "86",
        "AorC": "          "
    },
    "14845": {
        "Name": "Kane",
        "Number": "88",
        "AorC": "A         "
    },
    "14846": {
        "Name": "Nazar",
        "Number": "91",
        "AorC": "          "
    },
    "14847": {
        "Name": "Bedard",
        "Number": "98",
        "AorC": "C         "
    },
    "14848": {
        "Name": "Toews",
        "Number": "7",
        "AorC": "          "
    },
    "14849": {
        "Name": "Makar",
        "Number": "8",
        "AorC": "A         "
    },
    "14850": {
        "Name": "Roy",
        "Number": "10",
        "AorC": "          "
    },
    "14851": {
        "Name": "Nelson",
        "Number": "11",
        "AorC": "          "
    },
    "14852": {
        "Name": "Kelly",
        "Number": "17",
        "AorC": "          "
    },
    "14853": {
        "Name": "Lysell",
        "Number": "23",
        "AorC": "          "
    },
    "14854": {
        "Name": "O'Connor",
        "Number": "25",
        "AorC": "          "
    },
    "14855": {
        "Name": "Kulak",
        "Number": "27",
        "AorC": "          "
    },
    "14856": {
        "Name": "MacKinnon",
        "Number": "29",
        "AorC": "A         "
    },
    "14857": {
        "Name": "Nabokov",
        "Number": "30",
        "AorC": "          "
    },
    "14858": {
        "Name": "Blackwood",
        "Number": "39",
        "AorC": "          "
    },
    "14859": {
        "Name": "Wedgewood",
        "Number": "41",
        "AorC": "          "
    },
    "14860": {
        "Name": "Manson",
        "Number": "42",
        "AorC": "          "
    },
    "14861": {
        "Name": "Lehkonen",
        "Number": "62",
        "AorC": "          "
    },
    "14862": {
        "Name": "Malinski",
        "Number": "70",
        "AorC": "          "
    },
    "14863": {
        "Name": "Burns",
        "Number": "84",
        "AorC": "          "
    },
    "14864": {
        "Name": "Necas",
        "Number": "88",
        "AorC": "          "
    },
    "14865": {
        "Name": "Kadri",
        "Number": "91",
        "AorC": "          "
    },
    "14866": {
        "Name": "Landeskog",
        "Number": "92",
        "AorC": "C         "
    },
    "14867": {
        "Name": "Christiansen",
        "Number": "2",
        "AorC": "          "
    },
    "14868": {
        "Name": "Coyle",
        "Number": "3",
        "AorC": "          "
    },
    "14869": {
        "Name": "Sillinger",
        "Number": "4",
        "AorC": "          "
    },
    "14870": {
        "Name": "Mateychuk",
        "Number": "5",
        "AorC": "          "
    },
    "14871": {
        "Name": "Smith",
        "Number": "7",
        "AorC": "          "
    },
    "14872": {
        "Name": "Werenski",
        "Number": "8",
        "AorC": "A         "
    },
    "14873": {
        "Name": "Provorov",
        "Number": "9",
        "AorC": "          "
    },
    "14874": {
        "Name": "Voronkov",
        "Number": "10",
        "AorC": "          "
    },
    "14875": {
        "Name": "Fantilli",
        "Number": "19",
        "AorC": "          "
    },
    "14876": {
        "Name": "Monahan",
        "Number": "23",
        "AorC": "          "
    },
    "14877": {
        "Name": "Olivier",
        "Number": "24",
        "AorC": "          "
    },
    "14878": {
        "Name": "Lalonde",
        "Number": "31",
        "AorC": "          "
    },
    "14879": {
        "Name": "Talbot",
        "Number": "33",
        "AorC": "          "
    },
    "14880": {
        "Name": "Heinen",
        "Number": "43",
        "AorC": "          "
    },
    "14881": {
        "Name": "Nichushkin",
        "Number": "43",
        "AorC": "          "
    },
    "14882": {
        "Name": "Gudbranson",
        "Number": "44",
        "AorC": "          "
    },
    "14883": {
        "Name": "Greaves",
        "Number": "73",
        "AorC": "          "
    },
    "14884": {
        "Name": "Severson",
        "Number": "78",
        "AorC": "          "
    },
    "14885": {
        "Name": "Garland",
        "Number": "83",
        "AorC": "          "
    },
    "14887": {
        "Name": "Johnson",
        "Number": "91",
        "AorC": "          "
    },
    "14888": {
        "Name": "Lomberg",
        "Number": "94",
        "AorC": "          "
    },
    "14889": {
        "Name": "DeSmith",
        "Number": "1",
        "AorC": "          "
    },
    "14890": {
        "Name": "Heiskanen",
        "Number": "4",
        "AorC": "          "
    },
    "14891": {
        "Name": "Lundkvist",
        "Number": "5",
        "AorC": "          "
    },
    "14892": {
        "Name": "Bichsel",
        "Number": "6",
        "AorC": "          "
    },
    "14893": {
        "Name": "Back",
        "Number": "10",
        "AorC": "          "
    },
    "14894": {
        "Name": "Faksa",
        "Number": "12",
        "AorC": "          "
    },
    "14895": {
        "Name": "Benn",
        "Number": "14",
        "AorC": "C         "
    },
    "14896": {
        "Name": "Blackwell",
        "Number": "15",
        "AorC": "          "
    },
    "14897": {
        "Name": "Steel",
        "Number": "18",
        "AorC": "          "
    },
    "14898": {
        "Name": "Capobianco",
        "Number": "20",
        "AorC": "          "
    },
    "14899": {
        "Name": "Robertson",
        "Number": "21",
        "AorC": "          "
    },
    "14900": {
        "Name": "Kiviranta",
        "Number": "22",
        "AorC": "          "
    },
    "14901": {
        "Name": "Lindell",
        "Number": "23",
        "AorC": "          "
    },
    "14902": {
        "Name": "Hintz",
        "Number": "24",
        "AorC": "          "
    },
    "14903": {
        "Name": "Hyry",
        "Number": "25",
        "AorC": "          "
    },
    "14904": {
        "Name": "Taylor",
        "Number": "27",
        "AorC": "          "
    },
    "14905": {
        "Name": "Burroughs",
        "Number": "28",
        "AorC": "          "
    },
    "14906": {
        "Name": "Oettinger",
        "Number": "29",
        "AorC": "          "
    },
    "14907": {
        "Name": "Vanecek",
        "Number": "38",
        "AorC": "          "
    },
    "14908": {
        "Name": "Hemming",
        "Number": "39",
        "AorC": "          "
    },
    "14909": {
        "Name": "Anderson",
        "Number": "40",
        "AorC": "          "
    },
    "14910": {
        "Name": "Seminoff",
        "Number": "43",
        "AorC": "          "
    },
    "14911": {
        "Name": "Hryckowian",
        "Number": "46",
        "AorC": "          "
    },
    "14912": {
        "Name": "Hryckowian",
        "Number": "49",
        "AorC": "          "
    },
    "14913": {
        "Name": "Becker",
        "Number": "51",
        "AorC": "          "
    },
    "14914": {
        "Name": "Fitzgerald",
        "Number": "52",
        "AorC": "          "
    },
    "14915": {
        "Name": "Johnston",
        "Number": "53",
        "AorC": "          "
    },
    "14916": {
        "Name": "Harley",
        "Number": "55",
        "AorC": "          "
    },
    "14917": {
        "Name": "Myers",
        "Number": "57",
        "AorC": "          "
    },
    "14918": {
        "Name": "Bunting",
        "Number": "58",
        "AorC": "          "
    },
    "14919": {
        "Name": "Ertel",
        "Number": "62",
        "AorC": "          "
    },
    "14920": {
        "Name": "Paquette",
        "Number": "63",
        "AorC": "          "
    },
    "14921": {
        "Name": "Sgarbossa",
        "Number": "65",
        "AorC": "          "
    },
    "14922": {
        "Name": "Shlaine",
        "Number": "67",
        "AorC": "          "
    },
    "14923": {
        "Name": "McKenzie",
        "Number": "72",
        "AorC": "          "
    },
    "14924": {
        "Name": "Erne",
        "Number": "73",
        "AorC": "          "
    },
    "14925": {
        "Name": "Seguin",
        "Number": "91",
        "AorC": "          "
    },
    "14926": {
        "Name": "Duchene",
        "Number": "95",
        "AorC": "          "
    },
    "14927": {
        "Name": "Rantanen",
        "Number": "96",
        "AorC": "          "
    },
    "14928": {
        "Name": "Chiarot",
        "Number": "8",
        "AorC": "          "
    },
    "14929": {
        "Name": "Copp",
        "Number": "18",
        "AorC": "          "
    },
    "14930": {
        "Name": "Johansson",
        "Number": "20",
        "AorC": "          "
    },
    "14931": {
        "Name": "Appleton",
        "Number": "22",
        "AorC": "          "
    },
    "14932": {
        "Name": "Raymond",
        "Number": "23",
        "AorC": "A         "
    },
    "14933": {
        "Name": "Bernard-Docker",
        "Number": "25",
        "AorC": "          "
    },
    "14934": {
        "Name": "Rasmussen",
        "Number": "27",
        "AorC": "          "
    },
    "14935": {
        "Name": "Brandsegg-Nygard",
        "Number": "28",
        "AorC": "          "
    },
    "14936": {
        "Name": "Danielson",
        "Number": "29",
        "AorC": "          "
    },
    "14937": {
        "Name": "Augustine",
        "Number": "31",
        "AorC": "          "
    },
    "14938": {
        "Name": "Gylander",
        "Number": "32",
        "AorC": "          "
    },
    "14939": {
        "Name": "Arvidsson",
        "Number": "33",
        "AorC": "          "
    },
    "14940": {
        "Name": "Gibson",
        "Number": "36",
        "AorC": "          "
    },
    "14941": {
        "Name": "Compher",
        "Number": "37",
        "AorC": "          "
    },
    "14942": {
        "Name": "Muzzatti",
        "Number": "38",
        "AorC": "          "
    },
    "14943": {
        "Name": "Johansson",
        "Number": "42",
        "AorC": "          "
    },
    "14944": {
        "Name": "Sandin-Pellikka",
        "Number": "44",
        "AorC": "          "
    },
    "14945": {
        "Name": "Hamonic",
        "Number": "52",
        "AorC": "          "
    },
    "14946": {
        "Name": "Seider",
        "Number": "53",
        "AorC": "A         "
    },
    "14947": {
        "Name": "Wallinder",
        "Number": "54",
        "AorC": "          "
    },
    "14948": {
        "Name": "Kolesar",
        "Number": "55",
        "AorC": "          "
    },
    "14949": {
        "Name": "Finnie",
        "Number": "58",
        "AorC": "          "
    },
    "14950": {
        "Name": "Larkin",
        "Number": "71",
        "AorC": "          "
    },
    "14951": {
        "Name": "Faulk",
        "Number": "72",
        "AorC": "          "
    },
    "14952": {
        "Name": "Edvinsson",
        "Number": "77",
        "AorC": "          "
    },
    "14953": {
        "Name": "Tarasov",
        "Number": "80",
        "AorC": "          "
    },
    "14954": {
        "Name": "Kasper",
        "Number": "92",
        "AorC": "          "
    },
    "14955": {
        "Name": "DeBrincat",
        "Number": "93",
        "AorC": "A         "
    },
    "14956": {
        "Name": "Bouchard",
        "Number": "2",
        "AorC": "A         "
    },
    "14957": {
        "Name": "Murphy",
        "Number": "5",
        "AorC": "          "
    },
    "14958": {
        "Name": "Frederic",
        "Number": "10",
        "AorC": "          "
    },
    "14959": {
        "Name": "Formenton",
        "Number": "10",
        "AorC": "          "
    },
    "14960": {
        "Name": "Ekholm",
        "Number": "14",
        "AorC": "          "
    },
    "14961": {
        "Name": "Dickinson",
        "Number": "16",
        "AorC": "          "
    },
    "14962": {
        "Name": "Hyman",
        "Number": "18",
        "AorC": "A         "
    },
    "14963": {
        "Name": "Henrique",
        "Number": "19",
        "AorC": "          "
    },
    "14964": {
        "Name": "Savoie",
        "Number": "22",
        "AorC": "          "
    },
    "14965": {
        "Name": "Stastney",
        "Number": "24",
        "AorC": "          "
    },
    "14966": {
        "Name": "Draisaitl",
        "Number": "29",
        "AorC": "A         "
    },
    "14967": {
        "Name": "Andersen",
        "Number": "30",
        "AorC": "          "
    },
    "14968": {
        "Name": "Ungar",
        "Number": "32",
        "AorC": "          "
    },
    "14969": {
        "Name": "Dach",
        "Number": "34",
        "AorC": "          "
    },
    "14970": {
        "Name": "Jarry",
        "Number": "35",
        "AorC": "          "
    },
    "14971": {
        "Name": "Kapanen",
        "Number": "42",
        "AorC": "          "
    },
    "14972": {
        "Name": "Jones",
        "Number": "46",
        "AorC": "          "
    },
    "14973": {
        "Name": "Emberson",
        "Number": "49",
        "AorC": "          "
    },
    "14974": {
        "Name": "Samanski",
        "Number": "81",
        "AorC": "          "
    },
    "14975": {
        "Name": "Podkolzin",
        "Number": "92",
        "AorC": "          "
    },
    "14976": {
        "Name": "Nugent-Hopkins",
        "Number": "93",
        "AorC": "          "
    },
    "14977": {
        "Name": "Walman",
        "Number": "96",
        "AorC": "          "
    },
    "14978": {
        "Name": "McDavid",
        "Number": "97",
        "AorC": "C         "
    },
    "14979": {
        "Name": "Jones",
        "Number": "3",
        "AorC": "          "
    },
    "14980": {
        "Name": "Ekblad",
        "Number": "5",
        "AorC": "          "
    },
    "14981": {
        "Name": "Gudas",
        "Number": "6",
        "AorC": "          "
    },
    "14982": {
        "Name": "Sebrango",
        "Number": "6",
        "AorC": "          "
    },
    "14983": {
        "Name": "Kulikov",
        "Number": "7",
        "AorC": "          "
    },
    "14984": {
        "Name": "Tkachuk",
        "Number": "8",
        "AorC": "          "
    },
    "14985": {
        "Name": "Bennett",
        "Number": "9",
        "AorC": "          "
    },
    "14986": {
        "Name": "Reinhart",
        "Number": "13",
        "AorC": "          "
    },
    "14987": {
        "Name": "Lundell",
        "Number": "15",
        "AorC": "          "
    },
    "14988": {
        "Name": "Barkov",
        "Number": "16",
        "AorC": "C         "
    },
    "14989": {
        "Name": "Tkachuk",
        "Number": "19",
        "AorC": "A         "
    },
    "14990": {
        "Name": "Verhaeghe",
        "Number": "23",
        "AorC": "          "
    },
    "14991": {
        "Name": "Markstrom",
        "Number": "25",
        "AorC": "          "
    },
    "14992": {
        "Name": "Balinskis",
        "Number": "26",
        "AorC": "          "
    },
    "14993": {
        "Name": "Luostarinen",
        "Number": "27",
        "AorC": "          "
    },
    "14994": {
        "Name": "Reinhardt",
        "Number": "29",
        "AorC": "          "
    },
    "14995": {
        "Name": "Schmid",
        "Number": "40",
        "AorC": "          "
    },
    "14996": {
        "Name": "Forsling",
        "Number": "42",
        "AorC": "          "
    },
    "14997": {
        "Name": "Kunin",
        "Number": "71",
        "AorC": "          "
    },
    "14998": {
        "Name": "Mikkola",
        "Number": "77",
        "AorC": "          "
    },
    "14999": {
        "Name": "Schwindt",
        "Number": "79",
        "AorC": "          "
    },
    "15000": {
        "Name": "Brian Dumoulin",
        "Number": "2",
        "AorC": "          "
    },
    "15001": {
        "Name": "Cody Ceci",
        "Number": "5",
        "AorC": "          "
    },
    "15002": {
        "Name": "Joel Edmundson",
        "Number": "6",
        "AorC": "          "
    },
    "15003": {
        "Name": "Drew Doughty",
        "Number": "8",
        "AorC": "C         "
    },
    "15004": {
        "Name": "Adrian Kempe",
        "Number": "9",
        "AorC": "          "
    },
    "15005": {
        "Name": "Artemi Panarin",
        "Number": "10",
        "AorC": "          "
    },
    "15006": {
        "Name": "Trevor Moore",
        "Number": "12",
        "AorC": "          "
    },
    "15007": {
        "Name": "Alex Laferriere",
        "Number": "14",
        "AorC": "          "
    },
    "15008": {
        "Name": "Alex Turcotte",
        "Number": "15",
        "AorC": "          "
    },
    "15009": {
        "Name": "Scott Laughton",
        "Number": "21",
        "AorC": "          "
    },
    "15010": {
        "Name": "Anton Forsberg",
        "Number": "31",
        "AorC": "          "
    },
    "15011": {
        "Name": "Darcy Kuemper",
        "Number": "35",
        "AorC": "          "
    },
    "15012": {
        "Name": "Mats Zuccarello",
        "Number": "36",
        "AorC": "          "
    },
    "15013": {
        "Name": "Joel Armia",
        "Number": "40",
        "AorC": "          "
    },
    "15014": {
        "Name": "Mikey Anderson",
        "Number": "44",
        "AorC": "          "
    },
    "15015": {
        "Name": "Jared Wright",
        "Number": "53",
        "AorC": "          "
    },
    "15016": {
        "Name": "Quinton Byfield",
        "Number": "55",
        "AorC": "          "
    },
    "15017": {
        "Name": "Samuel Helenius",
        "Number": "79",
        "AorC": "          "
    },
    "15018": {
        "Name": "Corey Perry",
        "Number": "90",
        "AorC": "          "
    },
    "15019": {
        "Name": "Brandt Clarke",
        "Number": "92",
        "AorC": "          "
    },
    "15020": {
        "Name": "Petry",
        "Number": "2",
        "AorC": "          "
    },
    "15021": {
        "Name": "Maatta",
        "Number": "3",
        "AorC": "          "
    },
    "15022": {
        "Name": "Gustafsson-Nyberg",
        "Number": "6",
        "AorC": "          "
    },
    "15023": {
        "Name": "Faber",
        "Number": "7",
        "AorC": "          "
    },
    "15024": {
        "Name": "Brink",
        "Number": "10",
        "AorC": "          "
    },
    "15025": {
        "Name": "Boldy",
        "Number": "12",
        "AorC": "          "
    },
    "15026": {
        "Name": "Trenin",
        "Number": "13",
        "AorC": "          "
    },
    "15027": {
        "Name": "Eriksson Ek",
        "Number": "14",
        "AorC": "          "
    },
    "15028": {
        "Name": "Foligno",
        "Number": "17",
        "AorC": "          "
    },
    "15029": {
        "Name": "Coleman",
        "Number": "20",
        "AorC": "          "
    },
    "15030": {
        "Name": "Fabbri",
        "Number": "21",
        "AorC": "          "
    },
    "15031": {
        "Name": "Yurov",
        "Number": "22",
        "AorC": "          "
    },
    "15032": {
        "Name": "Bogosian",
        "Number": "24",
        "AorC": "          "
    },
    "15033": {
        "Name": "Brodin",
        "Number": "25",
        "AorC": "          "
    },
    "15034": {
        "Name": "Wallstedt",
        "Number": "30",
        "AorC": "          "
    },
    "15035": {
        "Name": "Pickard",
        "Number": "31",
        "AorC": "          "
    },
    "15036": {
        "Name": "Gustavsson",
        "Number": "32",
        "AorC": "          "
    },
    "15037": {
        "Name": "Haight",
        "Number": "37",
        "AorC": "          "
    },
    "15038": {
        "Name": "Hartman",
        "Number": "38",
        "AorC": "          "
    },
    "15039": {
        "Name": "Hughes",
        "Number": "43",
        "AorC": "          "
    },
    "15040": {
        "Name": "Spurgeon",
        "Number": "46",
        "AorC": "C         "
    },
    "15041": {
        "Name": "McCarron",
        "Number": "47",
        "AorC": "          "
    },
    "15042": {
        "Name": "Hunt",
        "Number": "48",
        "AorC": "          "
    },
    "15043": {
        "Name": "Shabanov",
        "Number": "49",
        "AorC": "          "
    },
    "15044": {
        "Name": "Mercer",
        "Number": "50",
        "AorC": "          "
    },
    "15045": {
        "Name": "Foligno",
        "Number": "71",
        "AorC": "          "
    },
    "15046": {
        "Name": "Sturm",
        "Number": "78",
        "AorC": "          "
    },
    "15047": {
        "Name": "Spacek",
        "Number": "82",
        "AorC": "          "
    },
    "15048": {
        "Name": "Tarasenko",
        "Number": "91",
        "AorC": "          "
    },
    "15049": {
        "Name": "Wutzke",
        "Number": "95",
        "AorC": "          "
    },
    "15050": {
        "Name": "Kaprizov",
        "Number": "97",
        "AorC": "          "
    },
    "15051": {
        "Name": "Matheson",
        "Number": "8",
        "AorC": "A         "
    },
    "15052": {
        "Name": "Caufield",
        "Number": "13",
        "AorC": "          "
    },
    "15053": {
        "Name": "Suzuki",
        "Number": "14",
        "AorC": "C         "
    },
    "15054": {
        "Name": "Newhook",
        "Number": "15",
        "AorC": "          "
    },
    "15055": {
        "Name": "Anderson",
        "Number": "17",
        "AorC": "A         "
    },
    "15056": {
        "Name": "Kreider",
        "Number": "20",
        "AorC": "          "
    },
    "15057": {
        "Name": "Slafkovsky",
        "Number": "20",
        "AorC": "          "
    },
    "15058": {
        "Name": "Guhle",
        "Number": "21",
        "AorC": "          "
    },
    "15059": {
        "Name": "Danault",
        "Number": "24",
        "AorC": "          "
    },
    "15060": {
        "Name": "Fowler",
        "Number": "32",
        "AorC": "          "
    },
    "15061": {
        "Name": "Montembeault",
        "Number": "35",
        "AorC": "          "
    },
    "15062": {
        "Name": "Engstrom",
        "Number": "42",
        "AorC": "          "
    },
    "15063": {
        "Name": "Carrier",
        "Number": "45",
        "AorC": "          "
    },
    "15064": {
        "Name": "Struble",
        "Number": "47",
        "AorC": "          "
    },
    "15065": {
        "Name": "Hutson",
        "Number": "48",
        "AorC": "          "
    },
    "15066": {
        "Name": "Dobson",
        "Number": "53",
        "AorC": "          "
    },
    "15067": {
        "Name": "Szuber",
        "Number": "55",
        "AorC": "          "
    },
    "15068": {
        "Name": "Beck",
        "Number": "62",
        "AorC": "          "
    },
    "15069": {
        "Name": "Reinbacher",
        "Number": "64",
        "AorC": "          "
    },
    "15070": {
        "Name": "Evans",
        "Number": "71",
        "AorC": "          "
    },
    "15071": {
        "Name": "Xhekaj",
        "Number": "72",
        "AorC": "          "
    },
    "15072": {
        "Name": "Dobes",
        "Number": "75",
        "AorC": "          "
    },
    "15073": {
        "Name": "Bolduc",
        "Number": "76",
        "AorC": "          "
    },
    "15074": {
        "Name": "Dach",
        "Number": "77",
        "AorC": "          "
    },
    "15075": {
        "Name": "Texier",
        "Number": "85",
        "AorC": "          "
    },
    "15076": {
        "Name": "Kapanen",
        "Number": "91",
        "AorC": "          "
    },
    "15077": {
        "Name": "Demidov",
        "Number": "93",
        "AorC": "          "
    },
    "15078": {
        "Name": "Gravel",
        "Number": "5",
        "AorC": "          "
    },
    "15079": {
        "Name": "Forsberg",
        "Number": "9",
        "AorC": "          "
    },
    "15080": {
        "Name": "Jost",
        "Number": "17",
        "AorC": "          "
    },
    "15081": {
        "Name": "Fink",
        "Number": "18",
        "AorC": "          "
    },
    "15082": {
        "Name": "O'Hara",
        "Number": "19",
        "AorC": "          "
    },
    "15083": {
        "Name": "Colton",
        "Number": "20",
        "AorC": "          "
    },
    "15084": {
        "Name": "Hoglander",
        "Number": "21",
        "AorC": "          "
    },
    "15085": {
        "Name": "Kemell",
        "Number": "25",
        "AorC": "          "
    },
    "15086": {
        "Name": "Annunen",
        "Number": "29",
        "AorC": "          "
    },
    "15087": {
        "Name": "Posch",
        "Number": "35",
        "AorC": "          "
    },
    "15088": {
        "Name": "Bradley",
        "Number": "38",
        "AorC": "          "
    },
    "15089": {
        "Name": "Hague",
        "Number": "41",
        "AorC": "          "
    },
    "15090": {
        "Name": "Perbix",
        "Number": "48",
        "AorC": "          "
    },
    "15091": {
        "Name": "Schaefer",
        "Number": "49",
        "AorC": "          "
    },
    "15092": {
        "Name": "Josi",
        "Number": "59",
        "AorC": "C         "
    },
    "15093": {
        "Name": "Wood",
        "Number": "71",
        "AorC": "          "
    },
    "15094": {
        "Name": "Saros",
        "Number": "74",
        "AorC": "          "
    },
    "15095": {
        "Name": "Skjei",
        "Number": "76",
        "AorC": "          "
    },
    "15096": {
        "Name": "Marchessault",
        "Number": "81",
        "AorC": "          "
    },
    "15097": {
        "Name": "Wilsby",
        "Number": "83",
        "AorC": "          "
    },
    "15098": {
        "Name": "Edstrom",
        "Number": "84",
        "AorC": "          "
    },
    "15099": {
        "Name": "Ufko",
        "Number": "85",
        "AorC": "          "
    },
    "15100": {
        "Name": "O'Reilly",
        "Number": "90",
        "AorC": "          "
    },
    "15101": {
        "Name": "Stamkos",
        "Number": "91",
        "AorC": "          "
    },
    "15102": {
        "Name": "Dillon",
        "Number": "5",
        "AorC": "          "
    },
    "15103": {
        "Name": "Hamilton",
        "Number": "7",
        "AorC": "          "
    },
    "15104": {
        "Name": "Kovacevic",
        "Number": "8",
        "AorC": "          "
    },
    "15105": {
        "Name": "Tufte",
        "Number": "10",
        "AorC": "          "
    },
    "15106": {
        "Name": "Noesen",
        "Number": "11",
        "AorC": "          "
    },
    "15107": {
        "Name": "Glass",
        "Number": "12",
        "AorC": "          "
    },
    "15108": {
        "Name": "Hischier",
        "Number": "13",
        "AorC": "C         "
    },
    "15109": {
        "Name": "Brown",
        "Number": "16",
        "AorC": "          "
    },
    "15110": {
        "Name": "Kolyachonok",
        "Number": "18",
        "AorC": "          "
    },
    "15111": {
        "Name": "Lachance",
        "Number": "20",
        "AorC": "          "
    },
    "15112": {
        "Name": "Pesce",
        "Number": "22",
        "AorC": "          "
    },
    "15113": {
        "Name": "Casey",
        "Number": "24",
        "AorC": "          "
    },
    "15114": {
        "Name": "Meier",
        "Number": "28",
        "AorC": "          "
    },
    "15115": {
        "Name": "Hameenaho",
        "Number": "29",
        "AorC": "          "
    },
    "15116": {
        "Name": "Malek",
        "Number": "31",
        "AorC": "          "
    },
    "15117": {
        "Name": "Dadonov",
        "Number": "33",
        "AorC": "          "
    },
    "15118": {
        "Name": "Rittich",
        "Number": "33",
        "AorC": "          "
    },
    "15119": {
        "Name": "Allen",
        "Number": "34",
        "AorC": "          "
    },
    "15120": {
        "Name": "White",
        "Number": "36",
        "AorC": "          "
    },
    "15121": {
        "Name": "Steeves",
        "Number": "37",
        "AorC": "          "
    },
    "15122": {
        "Name": "Hughes",
        "Number": "43",
        "AorC": "          "
    },
    "15123": {
        "Name": "Chisholm",
        "Number": "47",
        "AorC": "          "
    },
    "15124": {
        "Name": "Schmelzer",
        "Number": "49",
        "AorC": "          "
    },
    "15125": {
        "Name": "Daws",
        "Number": "50",
        "AorC": "          "
    },
    "15126": {
        "Name": "Silaev",
        "Number": "52",
        "AorC": "          "
    },
    "15127": {
        "Name": "Melovsky",
        "Number": "57",
        "AorC": "          "
    },
    "15128": {
        "Name": "Bratt",
        "Number": "63",
        "AorC": "          "
    },
    "15129": {
        "Name": "Parent",
        "Number": "67",
        "AorC": "          "
    },
    "15130": {
        "Name": "Siegenthaler",
        "Number": "71",
        "AorC": "          "
    },
    "15131": {
        "Name": "Bjugstad",
        "Number": "72",
        "AorC": "          "
    },
    "15132": {
        "Name": "Edwards",
        "Number": "73",
        "AorC": "          "
    },
    "15133": {
        "Name": "Squires",
        "Number": "75",
        "AorC": "          "
    },
    "15134": {
        "Name": "Gritsyuk",
        "Number": "81",
        "AorC": "          "
    },
    "15135": {
        "Name": "Hughes",
        "Number": "86",
        "AorC": "          "
    },
    "15136": {
        "Name": "Mercer",
        "Number": "91",
        "AorC": "          "
    },
    "15137": {
        "Name": "Lombardi",
        "Number": "93",
        "AorC": "          "
    },
    "15138": {
        "Name": "Pelech",
        "Number": "3",
        "AorC": "          "
    },
    "15139": {
        "Name": "Kessel",
        "Number": "4",
        "AorC": "          "
    },
    "15140": {
        "Name": "Pulock",
        "Number": "6",
        "AorC": "          "
    },
    "15141": {
        "Name": "Schenn",
        "Number": "10",
        "AorC": "          "
    },
    "15142": {
        "Name": "Duclair",
        "Number": "11",
        "AorC": "          "
    },
    "15143": {
        "Name": "Barzal",
        "Number": "13",
        "AorC": "          "
    },
    "15144": {
        "Name": "Horvat",
        "Number": "14",
        "AorC": "C         "
    },
    "15145": {
        "Name": "Highmore",
        "Number": "20",
        "AorC": "          "
    },
    "15146": {
        "Name": "Palmieri",
        "Number": "21",
        "AorC": "          "
    },
    "15147": {
        "Name": "Mayfield",
        "Number": "24",
        "AorC": "          "
    },
    "15148": {
        "Name": "Romanov",
        "Number": "28",
        "AorC": "          "
    },
    "15149": {
        "Name": "Sorokin",
        "Number": "30",
        "AorC": "          "
    },
    "15150": {
        "Name": "MacLean",
        "Number": "32",
        "AorC": "          "
    },
    "15151": {
        "Name": "Boqvist",
        "Number": "34",
        "AorC": "          "
    },
    "15152": {
        "Name": "George",
        "Number": "36",
        "AorC": "          "
    },
    "15153": {
        "Name": "Aitcheson",
        "Number": "37",
        "AorC": "          "
    },
    "15154": {
        "Name": "Vanecek",
        "Number": "41",
        "AorC": "          "
    },
    "15155": {
        "Name": "Pageau",
        "Number": "44",
        "AorC": "          "
    },
    "15156": {
        "Name": "Schaefer",
        "Number": "48",
        "AorC": "          "
    },
    "15157": {
        "Name": "Heineman",
        "Number": "51",
        "AorC": "          "
    },
    "15158": {
        "Name": "Cizikas",
        "Number": "53",
        "AorC": "          "
    },
    "15159": {
        "Name": "Eiserman",
        "Number": "57",
        "AorC": "          "
    },
    "15160": {
        "Name": "Larson",
        "Number": "61",
        "AorC": "          "
    },
    "15161": {
        "Name": "Ritchie",
        "Number": "64",
        "AorC": "          "
    },
    "15162": {
        "Name": "Veremyev",
        "Number": "67",
        "AorC": "          "
    },
    "15163": {
        "Name": "Dravecky",
        "Number": "71",
        "AorC": "          "
    },
    "15164": {
        "Name": "Eklund",
        "Number": "73",
        "AorC": "          "
    },
    "15165": {
        "Name": "DeAngelo",
        "Number": "77",
        "AorC": "          "
    },
    "15166": {
        "Name": "Palat",
        "Number": "81",
        "AorC": "          "
    },
    "15167": {
        "Name": "Holmstrom",
        "Number": "92",
        "AorC": "          "
    },
    "15168": {
        "Name": "Schneider",
        "Number": "4",
        "AorC": "          "
    },
    "15169": {
        "Name": "Iorio",
        "Number": "6",
        "AorC": "          "
    },
    "15170": {
        "Name": "Miller",
        "Number": "8",
        "AorC": "C         "
    },
    "15171": {
        "Name": "Lafreniere",
        "Number": "13",
        "AorC": "          "
    },
    "15172": {
        "Name": "Raddysh",
        "Number": "14",
        "AorC": "          "
    },
    "15173": {
        "Name": "Dorofeyev",
        "Number": "16",
        "AorC": "          "
    },
    "15174": {
        "Name": "Fox",
        "Number": "23",
        "AorC": "          "
    },
    "15175": {
        "Name": "Kartye",
        "Number": "24",
        "AorC": "          "
    },
    "15176": {
        "Name": "Robertson",
        "Number": "29",
        "AorC": "          "
    },
    "15177": {
        "Name": "Shesterkin",
        "Number": "31",
        "AorC": "          "
    },
    "15178": {
        "Name": "Garand",
        "Number": "33",
        "AorC": "          "
    },
    "15179": {
        "Name": "Sykora",
        "Number": "38",
        "AorC": "          "
    },
    "15180": {
        "Name": "Laba",
        "Number": "42",
        "AorC": "          "
    },
    "15181": {
        "Name": "Gavrikov",
        "Number": "44",
        "AorC": "          "
    },
    "15182": {
        "Name": "Fortescue",
        "Number": "45",
        "AorC": "          "
    },
    "15183": {
        "Name": "Chmelar",
        "Number": "49",
        "AorC": "          "
    },
    "15184": {
        "Name": "Cuylle",
        "Number": "50",
        "AorC": "          "
    },
    "15185": {
        "Name": "Smits",
        "Number": "63",
        "AorC": "          "
    },
    "15186": {
        "Name": "Rempe",
        "Number": "73",
        "AorC": "          "
    },
    "15187": {
        "Name": "Zibanejad",
        "Number": "93",
        "AorC": "          "
    },
    "15188": {
        "Name": "Perreault",
        "Number": "94",
        "AorC": "          "
    },
    "15189": {
        "Name": "Zherenko",
        "Number": "1",
        "AorC": "          "
    },
    "15190": {
        "Name": "Zub",
        "Number": "2",
        "AorC": "          "
    },
    "15191": {
        "Name": "Crotty",
        "Number": "5",
        "AorC": "          "
    },
    "15192": {
        "Name": "Spence",
        "Number": "10",
        "AorC": "          "
    },
    "15193": {
        "Name": "Pinto",
        "Number": "12",
        "AorC": "          "
    },
    "15194": {
        "Name": "Harrington",
        "Number": "17",
        "AorC": "          "
    },
    "15195": {
        "Name": "Stutzle",
        "Number": "18",
        "AorC": "          "
    },
    "15196": {
        "Name": "Batherson",
        "Number": "19",
        "AorC": "          "
    },
    "15197": {
        "Name": "Zetterlund",
        "Number": "20",
        "AorC": "          "
    },
    "15198": {
        "Name": "Cousins",
        "Number": "21",
        "AorC": "          "
    },
    "15199": {
        "Name": "Amadio",
        "Number": "22",
        "AorC": "          "
    },
    "15200": {
        "Name": "MacDermid",
        "Number": "23",
        "AorC": "          "
    },
    "15201": {
        "Name": "Cozens",
        "Number": "24",
        "AorC": "          "
    },
    "15202": {
        "Name": "Eklund",
        "Number": "27",
        "AorC": "          "
    },
    "15203": {
        "Name": "Giroux",
        "Number": "28",
        "AorC": "          "
    },
    "15204": {
        "Name": "Johansson",
        "Number": "31",
        "AorC": "          "
    },
    "15205": {
        "Name": "Parsons",
        "Number": "31",
        "AorC": "          "
    },
    "15206": {
        "Name": "Matinpalo",
        "Number": "33",
        "AorC": "          "
    },
    "15207": {
        "Name": "Ullmark",
        "Number": "35",
        "AorC": "          "
    },
    "15208": {
        "Name": "Foegele",
        "Number": "37",
        "AorC": "          "
    },
    "15209": {
        "Name": "Hodgson",
        "Number": "42",
        "AorC": "          "
    },
    "15210": {
        "Name": "Kleven",
        "Number": "43",
        "AorC": "          "
    },
    "15211": {
        "Name": "Reimer",
        "Number": "47",
        "AorC": "          "
    },
    "15212": {
        "Name": "Greig",
        "Number": "71",
        "AorC": "          "
    },
    "15213": {
        "Name": "Chabot",
        "Number": "72",
        "AorC": "A         "
    },
    "15214": {
        "Name": "Halliday",
        "Number": "83",
        "AorC": "          "
    },
    "15215": {
        "Name": "Sanderson",
        "Number": "85",
        "AorC": "          "
    },
    "15216": {
        "Name": "Grans",
        "Number": "3",
        "AorC": "          "
    },
    "15217": {
        "Name": "Jiricek",
        "Number": "5",
        "AorC": "          "
    },
    "15218": {
        "Name": "Sanheim",
        "Number": "6",
        "AorC": "          "
    },
    "15219": {
        "Name": "York",
        "Number": "8",
        "AorC": "          "
    },
    "15220": {
        "Name": "Drysdale",
        "Number": "9",
        "AorC": "          "
    },
    "15221": {
        "Name": "Wilson",
        "Number": "10",
        "AorC": "          "
    },
    "15222": {
        "Name": "Konecny",
        "Number": "11",
        "AorC": "          "
    },
    "15223": {
        "Name": "Couturier",
        "Number": "14",
        "AorC": "C         "
    },
    "15224": {
        "Name": "Luchanko",
        "Number": "17",
        "AorC": "          "
    },
    "15225": {
        "Name": "Bump",
        "Number": "20",
        "AorC": "          "
    },
    "15226": {
        "Name": "Dvorak",
        "Number": "22",
        "AorC": "          "
    },
    "15227": {
        "Name": "Seeler",
        "Number": "24",
        "AorC": "          "
    },
    "15228": {
        "Name": "Cates",
        "Number": "27",
        "AorC": "          "
    },
    "15229": {
        "Name": "Grebenkin",
        "Number": "29",
        "AorC": "          "
    },
    "15230": {
        "Name": "Kolosov",
        "Number": "35",
        "AorC": "          "
    },
    "15231": {
        "Name": "Michkov",
        "Number": "39",
        "AorC": "          "
    },
    "15232": {
        "Name": "Benoit",
        "Number": "44",
        "AorC": "          "
    },
    "15233": {
        "Name": "Zegras",
        "Number": "46",
        "AorC": "          "
    },
    "15234": {
        "Name": "Acciari",
        "Number": "52",
        "AorC": "          "
    },
    "15235": {
        "Name": "Woll",
        "Number": "53",
        "AorC": "          "
    },
    "15236": {
        "Name": "Ristolainen",
        "Number": "55",
        "AorC": "          "
    },
    "15237": {
        "Name": "Bonk",
        "Number": "59",
        "AorC": "          "
    },
    "15238": {
        "Name": "Perets",
        "Number": "60",
        "AorC": "          "
    },
    "15239": {
        "Name": "Bjarnason",
        "Number": "64",
        "AorC": "          "
    },
    "15240": {
        "Name": "Foerster",
        "Number": "71",
        "AorC": "          "
    },
    "15241": {
        "Name": "Tippett",
        "Number": "74",
        "AorC": "          "
    },
    "15242": {
        "Name": "McDonald",
        "Number": "75",
        "AorC": "          "
    },
    "15243": {
        "Name": "Gaucher",
        "Number": "78",
        "AorC": "          "
    },
    "15244": {
        "Name": "Vladar",
        "Number": "80",
        "AorC": "          "
    },
    "15245": {
        "Name": "Barkey",
        "Number": "86",
        "AorC": "          "
    },
    "15246": {
        "Name": "Martone",
        "Number": "94",
        "AorC": "          "
    },
    "15247": {
        "Name": "McGroarty",
        "Number": "2",
        "AorC": "          "
    },
    "15248": {
        "Name": "Korczak",
        "Number": "6",
        "AorC": "          "
    },
    "15249": {
        "Name": "Solovyov",
        "Number": "7",
        "AorC": "          "
    },
    "15250": {
        "Name": "Hallander",
        "Number": "11",
        "AorC": "          "
    },
    "15251": {
        "Name": "Robertson",
        "Number": "14",
        "AorC": "          "
    },
    "15252": {
        "Name": "Brazeau",
        "Number": "16",
        "AorC": "          "
    },
    "15253": {
        "Name": "Rust",
        "Number": "17",
        "AorC": "          "
    },
    "15254": {
        "Name": "Novak",
        "Number": "18",
        "AorC": "          "
    },
    "15255": {
        "Name": "Dewar",
        "Number": "19",
        "AorC": "          "
    },
    "15256": {
        "Name": "Zonnon",
        "Number": "23",
        "AorC": "          "
    },
    "15257": {
        "Name": "Soderblom",
        "Number": "25",
        "AorC": "          "
    },
    "15258": {
        "Name": "Graves",
        "Number": "27",
        "AorC": "          "
    },
    "15259": {
        "Name": "Galvas",
        "Number": "32",
        "AorC": "          "
    },
    "15260": {
        "Name": "Silovs",
        "Number": "37",
        "AorC": "          "
    },
    "15261": {
        "Name": "Lizotte",
        "Number": "46",
        "AorC": "          "
    },
    "15262": {
        "Name": "Girard",
        "Number": "49",
        "AorC": "          "
    },
    "15263": {
        "Name": "Harding",
        "Number": "50",
        "AorC": "          "
    },
    "15264": {
        "Name": "Letang",
        "Number": "58",
        "AorC": "          "
    },
    "15265": {
        "Name": "Chinakhov",
        "Number": "59",
        "AorC": "          "
    },
    "15266": {
        "Name": "Karlsson",
        "Number": "65",
        "AorC": "          "
    },
    "15267": {
        "Name": "Rakell",
        "Number": "67",
        "AorC": "          "
    },
    "15268": {
        "Name": "Malkin",
        "Number": "71",
        "AorC": "          "
    },
    "15269": {
        "Name": "Carlile",
        "Number": "72",
        "AorC": "          "
    },
    "15270": {
        "Name": "Kindel",
        "Number": "81",
        "AorC": "          "
    },
    "15271": {
        "Name": "Calvert",
        "Number": "84",
        "AorC": "          "
    },
    "15272": {
        "Name": "Crosby",
        "Number": "87",
        "AorC": "C         "
    },
    "15273": {
        "Name": "Smith",
        "Number": "2",
        "AorC": "          "
    },
    "15274": {
        "Name": "Leddy",
        "Number": "4",
        "AorC": "          "
    },
    "15275": {
        "Name": "Dickinson",
        "Number": "6",
        "AorC": "          "
    },
    "15276": {
        "Name": "Kesselring",
        "Number": "7",
        "AorC": "          "
    },
    "15277": {
        "Name": "Orlov",
        "Number": "9",
        "AorC": "          "
    },
    "15278": {
        "Name": "Dellandrea",
        "Number": "10",
        "AorC": "          "
    },
    "15279": {
        "Name": "Leason",
        "Number": "20",
        "AorC": "          "
    },
    "15280": {
        "Name": "Wennberg",
        "Number": "21",
        "AorC": "          "
    },
    "15281": {
        "Name": "Goodrow",
        "Number": "23",
        "AorC": "          "
    },
    "15282": {
        "Name": "Nurse",
        "Number": "25",
        "AorC": "          "
    },
    "15283": {
        "Name": "Askarov",
        "Number": "30",
        "AorC": "          "
    },
    "15284": {
        "Name": "Nedeljkovic",
        "Number": "33",
        "AorC": "          "
    },
    "15285": {
        "Name": "Samsonov",
        "Number": "35",
        "AorC": "          "
    },
    "15286": {
        "Name": "Sherwood",
        "Number": "44",
        "AorC": "          "
    },
    "15287": {
        "Name": "Graf",
        "Number": "51",
        "AorC": "          "
    },
    "15288": {
        "Name": "Ostapchuk",
        "Number": "63",
        "AorC": "          "
    },
    "15289": {
        "Name": "Trouba",
        "Number": "65",
        "AorC": "          "
    },
    "15290": {
        "Name": "Celebrini",
        "Number": "71",
        "AorC": "C         "
    },
    "15291": {
        "Name": "Toffoli",
        "Number": "73",
        "AorC": "          "
    },
    "15292": {
        "Name": "Misa",
        "Number": "77",
        "AorC": "          "
    },
    "15293": {
        "Name": "Gaudette",
        "Number": "81",
        "AorC": "          "
    },
    "15294": {
        "Name": "Regenda",
        "Number": "84",
        "AorC": "          "
    },
    "15295": {
        "Name": "Keyser",
        "Number": "85",
        "AorC": "          "
    },
    "15296": {
        "Name": "Kurashev",
        "Number": "96",
        "AorC": "          "
    },
    "15297": {
        "Name": "Larsson",
        "Number": "6",
        "AorC": "          "
    },
    "15298": {
        "Name": "Eberle",
        "Number": "7",
        "AorC": "C         "
    },
    "15299": {
        "Name": "Fleury",
        "Number": "8",
        "AorC": "          "
    },
    "15300": {
        "Name": "Stephenson",
        "Number": "9",
        "AorC": "          "
    },
    "15301": {
        "Name": "Beniers",
        "Number": "10",
        "AorC": "          "
    },
    "15302": {
        "Name": "McCann",
        "Number": "19",
        "AorC": "          "
    },
    "15303": {
        "Name": "Winterton",
        "Number": "26",
        "AorC": "          "
    },
    "15304": {
        "Name": "Catton",
        "Number": "27",
        "AorC": "          "
    },
    "15305": {
        "Name": "Mahura",
        "Number": "28",
        "AorC": "          "
    },
    "15306": {
        "Name": "Dunn",
        "Number": "29",
        "AorC": "          "
    },
    "15307": {
        "Name": "Murray",
        "Number": "30",
        "AorC": "          "
    },
    "15308": {
        "Name": "Grubauer",
        "Number": "31",
        "AorC": "          "
    },
    "15309": {
        "Name": "Daccord",
        "Number": "35",
        "AorC": "          "
    },
    "15310": {
        "Name": "Nyman",
        "Number": "38",
        "AorC": "          "
    },
    "15311": {
        "Name": "Evans",
        "Number": "41",
        "AorC": "          "
    },
    "15312": {
        "Name": "Wright",
        "Number": "51",
        "AorC": "          "
    },
    "15313": {
        "Name": "Lindgren",
        "Number": "55",
        "AorC": "          "
    },
    "15314": {
        "Name": "Meyers",
        "Number": "59",
        "AorC": "          "
    },
    "15315": {
        "Name": "Montour",
        "Number": "62",
        "AorC": "          "
    },
    "15316": {
        "Name": "Melanson",
        "Number": "63",
        "AorC": "          "
    },
    "15317": {
        "Name": "McMann",
        "Number": "74",
        "AorC": "          "
    },
    "15318": {
        "Name": "Fisker Molgaard",
        "Number": "78",
        "AorC": "          "
    },
    "15319": {
        "Name": "Kakko",
        "Number": "84",
        "AorC": "          "
    },
    "15320": {
        "Name": "Gaudreau",
        "Number": "89",
        "AorC": "          "
    },
    "15321": {
        "Name": "Broberg",
        "Number": "6",
        "AorC": "          "
    },
    "15322": {
        "Name": "Toropchenko",
        "Number": "13",
        "AorC": "          "
    },
    "15323": {
        "Name": "Fowler",
        "Number": "17",
        "AorC": "          "
    },
    "15324": {
        "Name": "Thomas",
        "Number": "18",
        "AorC": "C         "
    },
    "15325": {
        "Name": "Snuggerud",
        "Number": "21",
        "AorC": "          "
    },
    "15326": {
        "Name": "Suter",
        "Number": "22",
        "AorC": "          "
    },
    "15327": {
        "Name": "McTavish",
        "Number": "23",
        "AorC": "          "
    },
    "15328": {
        "Name": "Mailloux",
        "Number": "23",
        "AorC": "          "
    },
    "15329": {
        "Name": "McMichael",
        "Number": "24",
        "AorC": "          "
    },
    "15330": {
        "Name": "Carlo",
        "Number": "25",
        "AorC": "          "
    },
    "15331": {
        "Name": "Berggren",
        "Number": "29",
        "AorC": "          "
    },
    "15332": {
        "Name": "Hofer",
        "Number": "30",
        "AorC": "          "
    },
    "15333": {
        "Name": "Koromyslov",
        "Number": "48",
        "AorC": "          "
    },
    "15334": {
        "Name": "Binnington",
        "Number": "50",
        "AorC": "          "
    },
    "15335": {
        "Name": "Ralph",
        "Number": "51",
        "AorC": "          "
    },
    "15336": {
        "Name": "Dvorsky",
        "Number": "54",
        "AorC": "          "
    },
    "15337": {
        "Name": "Parayko",
        "Number": "55",
        "AorC": "          "
    },
    "15338": {
        "Name": "Neighbours",
        "Number": "63",
        "AorC": "          "
    },
    "15339": {
        "Name": "Dube",
        "Number": "65",
        "AorC": "          "
    },
    "15340": {
        "Name": "Tucker",
        "Number": "75",
        "AorC": "          "
    },
    "15341": {
        "Name": "Holloway",
        "Number": "81",
        "AorC": "          "
    },
    "15342": {
        "Name": "Dagenais",
        "Number": "82",
        "AorC": "          "
    },
    "15343": {
        "Name": "Buchnevich",
        "Number": "89",
        "AorC": "          "
    },
    "15344": {
        "Name": "Geekie",
        "Number": "14",
        "AorC": "          "
    },
    "15345": {
        "Name": "James",
        "Number": "17",
        "AorC": "          "
    },
    "15346": {
        "Name": "Point",
        "Number": "21",
        "AorC": "          "
    },
    "15347": {
        "Name": "O'Reilly",
        "Number": "23",
        "AorC": "          "
    },
    "15348": {
        "Name": "Crozier",
        "Number": "24",
        "AorC": "          "
    },
    "15349": {
        "Name": "McDonagh",
        "Number": "27",
        "AorC": "          "
    },
    "15350": {
        "Name": "Girgensons",
        "Number": "28",
        "AorC": "          "
    },
    "15351": {
        "Name": "Holmberg",
        "Number": "29",
        "AorC": "          "
    },
    "15352": {
        "Name": "Hildeby",
        "Number": "35",
        "AorC": "          "
    },
    "15353": {
        "Name": "Gourde",
        "Number": "37",
        "AorC": "          "
    },
    "15354": {
        "Name": "Hagel",
        "Number": "38",
        "AorC": "          "
    },
    "15355": {
        "Name": "Sabourin",
        "Number": "46",
        "AorC": "          "
    },
    "15356": {
        "Name": "D'Astous",
        "Number": "51",
        "AorC": "          "
    },
    "15357": {
        "Name": "Guentzel",
        "Number": "59",
        "AorC": "          "
    },
    "15358": {
        "Name": "Cirelli",
        "Number": "71",
        "AorC": "          "
    },
    "15359": {
        "Name": "Carlson",
        "Number": "74",
        "AorC": "          "
    },
    "15360": {
        "Name": "Hedman",
        "Number": "77",
        "AorC": "C         "
    },
    "15361": {
        "Name": "Martinsen",
        "Number": "78",
        "AorC": "          "
    },
    "15362": {
        "Name": "Cernak",
        "Number": "81",
        "AorC": "          "
    },
    "15363": {
        "Name": "Kucherov",
        "Number": "86",
        "AorC": "          "
    },
    "15364": {
        "Name": "Vasilevskiy",
        "Number": "88",
        "AorC": "          "
    },
    "15365": {
        "Name": "Moser",
        "Number": "90",
        "AorC": "          "
    },
    "15366": {
        "Name": "Goncalves",
        "Number": "93",
        "AorC": "          "
    },
    "15367": {
        "Name": "McWard",
        "Number": "4",
        "AorC": "          "
    },
    "15368": {
        "Name": "Tanev",
        "Number": "8",
        "AorC": "          "
    },
    "15369": {
        "Name": "Domi",
        "Number": "11",
        "AorC": "          "
    },
    "15370": {
        "Name": "Paul",
        "Number": "20",
        "AorC": "          "
    },
    "15371": {
        "Name": "McCabe",
        "Number": "22",
        "AorC": "          "
    },
    "15373": {
        "Name": "Stecher",
        "Number": "28",
        "AorC": "          "
    },
    "15374": {
        "Name": "Matthews",
        "Number": "34",
        "AorC": "C         "
    },
    "15375": {
        "Name": "Stolarz",
        "Number": "41",
        "AorC": "          "
    },
    "15376": {
        "Name": "Raddysh",
        "Number": "43",
        "AorC": "          "
    },
    "15377": {
        "Name": "Rielly",
        "Number": "44",
        "AorC": "          "
    },
    "15378": {
        "Name": "Cowan",
        "Number": "53",
        "AorC": "          "
    },
    "15379": {
        "Name": "Rybinski",
        "Number": "58",
        "AorC": "          "
    },
    "15380": {
        "Name": "Bobrovsky",
        "Number": "72",
        "AorC": "          "
    },
    "15381": {
        "Name": "Joshua",
        "Number": "81",
        "AorC": "          "
    },
    "15382": {
        "Name": "Nylander",
        "Number": "88",
        "AorC": "          "
    },
    "15383": {
        "Name": "Tavares",
        "Number": "91",
        "AorC": "A         "
    },
    "15384": {
        "Name": "McKenna",
        "Number": "92",
        "AorC": "          "
    },
    "15385": {
        "Name": "Ekman-Larsson",
        "Number": "95",
        "AorC": "          "
    },
    "15386": {
        "Name": "Marino",
        "Number": "6",
        "AorC": "          "
    },
    "15387": {
        "Name": "Schmaltz",
        "Number": "8",
        "AorC": "          "
    },
    "15388": {
        "Name": "Keller",
        "Number": "9",
        "AorC": "C         "
    },
    "15389": {
        "Name": "Lamoureux",
        "Number": "10",
        "AorC": "          "
    },
    "15390": {
        "Name": "Guenther",
        "Number": "11",
        "AorC": "          "
    },
    "15391": {
        "Name": "Trocheck",
        "Number": "16",
        "AorC": "          "
    },
    "15392": {
        "Name": "But",
        "Number": "19",
        "AorC": "          "
    },
    "15393": {
        "Name": "McBain",
        "Number": "22",
        "AorC": "          "
    },
    "15394": {
        "Name": "Rooney",
        "Number": "25",
        "AorC": "          "
    },
    "15395": {
        "Name": "Simashev",
        "Number": "26",
        "AorC": "          "
    },
    "15396": {
        "Name": "Hayton",
        "Number": "27",
        "AorC": "          "
    },
    "15397": {
        "Name": "Stauber",
        "Number": "33",
        "AorC": "          "
    },
    "15398": {
        "Name": "O'Brien",
        "Number": "38",
        "AorC": "          "
    },
    "15399": {
        "Name": "Weegar",
        "Number": "52",
        "AorC": "          "
    },
    "15400": {
        "Name": "Carcone",
        "Number": "53",
        "AorC": "          "
    },
    "15401": {
        "Name": "Yamamoto",
        "Number": "56",
        "AorC": "          "
    },
    "15402": {
        "Name": "DeSimone",
        "Number": "57",
        "AorC": "          "
    },
    "15403": {
        "Name": "McCartney",
        "Number": "62",
        "AorC": "          "
    },
    "15404": {
        "Name": "Crouse",
        "Number": "67",
        "AorC": "          "
    },
    "15405": {
        "Name": "Vejmelka",
        "Number": "70",
        "AorC": "          "
    },
    "15406": {
        "Name": "Lee",
        "Number": "72",
        "AorC": "          "
    },
    "15407": {
        "Name": "Hebig",
        "Number": "78",
        "AorC": "          "
    },
    "15408": {
        "Name": "Stenlund",
        "Number": "82",
        "AorC": "          "
    },
    "15409": {
        "Name": "Schmidt",
        "Number": "88",
        "AorC": "          "
    },
    "15410": {
        "Name": "Roy",
        "Number": "89",
        "AorC": "          "
    },
    "15411": {
        "Name": "Cooley",
        "Number": "92",
        "AorC": "          "
    },
    "15412": {
        "Name": "Sergachev",
        "Number": "98",
        "AorC": "          "
    },
    "15413": {
        "Name": "Leevi Merilainen",
        "Number": "1",
        "AorC": "          "
    },
    "15414": {
        "Name": "Luke Schenn",
        "Number": "2",
        "AorC": "          "
    },
    "15415": {
        "Name": "Jamie Oleksiak",
        "Number": "4",
        "AorC": "          "
    },
    "15416": {
        "Name": "Tom Willander",
        "Number": "5",
        "AorC": "          "
    },
    "15417": {
        "Name": "Brock Boeser",
        "Number": "6",
        "AorC": "A         "
    },
    "15418": {
        "Name": "Brendan Gallagher",
        "Number": "7",
        "AorC": "          "
    },
    "15419": {
        "Name": "Filip Hronek",
        "Number": "17",
        "AorC": "A         "
    },
    "15420": {
        "Name": "Drew O'Connor",
        "Number": "18",
        "AorC": "          "
    },
    "15421": {
        "Name": "Zeev Buium",
        "Number": "24",
        "AorC": "          "
    },
    "15422": {
        "Name": "Elias Pettersson",
        "Number": "25",
        "AorC": "          "
    },
    "15423": {
        "Name": "Derek Forbort",
        "Number": "27",
        "AorC": "          "
    },
    "15424": {
        "Name": "Kevin Lankinen",
        "Number": "32",
        "AorC": "          "
    },
    "15425": {
        "Name": "Matthew Stienburg",
        "Number": "36",
        "AorC": "          "
    },
    "15426": {
        "Name": "Elias Pettersson",
        "Number": "40",
        "AorC": "A         "
    },
    "15427": {
        "Name": "Aatu Raty",
        "Number": "54",
        "AorC": "          "
    },
    "15428": {
        "Name": "Chris Driedger",
        "Number": "60",
        "AorC": "          "
    },
    "15429": {
        "Name": "Nikita Tolopilo",
        "Number": "60",
        "AorC": "          "
    },
    "15430": {
        "Name": "Max Sasson",
        "Number": "63",
        "AorC": "          "
    },
    "15431": {
        "Name": "Jake DeBrusk",
        "Number": "74",
        "AorC": "          "
    },
    "15432": {
        "Name": "Victor Mancini",
        "Number": "90",
        "AorC": "          "
    },
    "15433": {
        "Name": "Evander Kane",
        "Number": "91",
        "AorC": "          "
    },
    "15434": {
        "Name": "Liam Ohgren",
        "Number": "92",
        "AorC": "          "
    },
    "15435": {
        "Name": "Marco Rossi",
        "Number": "93",
        "AorC": "          "
    },
    "15436": {
        "Name": "Linus Karlsson",
        "Number": "94",
        "AorC": "          "
    },
    "15437": {
        "Name": "Roy",
        "Number": "3",
        "AorC": "          "
    },
    "15438": {
        "Name": "Chychrun",
        "Number": "6",
        "AorC": "          "
    },
    "15439": {
        "Name": "Ovechkin",
        "Number": "8",
        "AorC": "C         "
    },
    "15440": {
        "Name": "Leonard",
        "Number": "9",
        "AorC": "          "
    },
    "15441": {
        "Name": "Lakovic",
        "Number": "14",
        "AorC": "          "
    },
    "15442": {
        "Name": "Strome",
        "Number": "17",
        "AorC": "          "
    },
    "15443": {
        "Name": "Protas",
        "Number": "21",
        "AorC": "          "
    },
    "15444": {
        "Name": "Jenner",
        "Number": "22",
        "AorC": "          "
    },
    "15445": {
        "Name": "Kyrou",
        "Number": "25",
        "AorC": "          "
    },
    "15446": {
        "Name": "Liljegren",
        "Number": "27",
        "AorC": "          "
    },
    "15447": {
        "Name": "Stevenson",
        "Number": "33",
        "AorC": "          "
    },
    "15448": {
        "Name": "Sourdif",
        "Number": "34",
        "AorC": "          "
    },
    "15449": {
        "Name": "Sandin",
        "Number": "38",
        "AorC": "          "
    },
    "15450": {
        "Name": "Fehervary",
        "Number": "42",
        "AorC": "          "
    },
    "15451": {
        "Name": "Wilson",
        "Number": "43",
        "AorC": "          "
    },
    "15452": {
        "Name": "Hutson",
        "Number": "44",
        "AorC": "          "
    },
    "15453": {
        "Name": "Thompson",
        "Number": "48",
        "AorC": "          "
    },
    "15454": {
        "Name": "McIlrath",
        "Number": "52",
        "AorC": "          "
    },
    "15455": {
        "Name": "Frank",
        "Number": "53",
        "AorC": "          "
    },
    "15456": {
        "Name": "Protas",
        "Number": "62",
        "AorC": "          "
    },
    "15457": {
        "Name": "Miroshnichenko",
        "Number": "63",
        "AorC": "          "
    },
    "15458": {
        "Name": "Sikora",
        "Number": "66",
        "AorC": "          "
    },
    "15459": {
        "Name": "Beauvillier",
        "Number": "72",
        "AorC": "          "
    },
    "15460": {
        "Name": "Desharnais",
        "Number": "73",
        "AorC": "          "
    },
    "15461": {
        "Name": "Brodzinski",
        "Number": "76",
        "AorC": "          "
    },
    "15462": {
        "Name": "Lindgren",
        "Number": "79",
        "AorC": "          "
    },
    "15463": {
        "Name": "Dubois",
        "Number": "80",
        "AorC": "          "
    },
    "15464": {
        "Name": "Tuch",
        "Number": "89",
        "AorC": "          "
    },
    "15465": {
        "Name": "DeMelo",
        "Number": "2",
        "AorC": "          "
    },
    "15466": {
        "Name": "St. Ivany",
        "Number": "3",
        "AorC": "          "
    },
    "15467": {
        "Name": "Pionk",
        "Number": "4",
        "AorC": "          "
    },
    "15468": {
        "Name": "Namestnikov",
        "Number": "7",
        "AorC": "          "
    },
    "15469": {
        "Name": "Iafallo",
        "Number": "9",
        "AorC": "          "
    },
    "15470": {
        "Name": "Vilardi",
        "Number": "13",
        "AorC": "          "
    },
    "15471": {
        "Name": "Nyquist",
        "Number": "14",
        "AorC": "          "
    },
    "15472": {
        "Name": "Lowry",
        "Number": "17",
        "AorC": "C         "
    },
    "15473": {
        "Name": "Fleury",
        "Number": "24",
        "AorC": "          "
    },
    "15474": {
        "Name": "Rosen",
        "Number": "27",
        "AorC": "          "
    },
    "15475": {
        "Name": "Barron",
        "Number": "36",
        "AorC": "          "
    },
    "15476": {
        "Name": "Morrissey",
        "Number": "44",
        "AorC": "          "
    },
    "15477": {
        "Name": "Koepke",
        "Number": "45",
        "AorC": "          "
    },
    "15478": {
        "Name": "Samberg",
        "Number": "54",
        "AorC": "          "
    },
    "15479": {
        "Name": "Scheifele",
        "Number": "55",
        "AorC": "A         "
    },
    "15480": {
        "Name": "Niederreiter",
        "Number": "62",
        "AorC": "          "
    },
    "15481": {
        "Name": "Skinner",
        "Number": "74",
        "AorC": "          "
    },
    "15482": {
        "Name": "Connor",
        "Number": "81",
        "AorC": "          "
    },
    "15483": {
        "Name": "Perfetti",
        "Number": "91",
        "AorC": "          "
    },
    "15484": {
        "Name": "Knies",
        "Number": "89",
        "AorC": "          "
    },
    "15485": {
        "Name": "Lorentz",
        "Number": "18",
        "AorC": "          "
    },
    "15486": {
        "Name": "Andrae",
        "Number": "55",
        "AorC": "          "
    },
    "15487": {
        "Name": "Blankenburg",
        "Number": "3",
        "AorC": "          "
    },
    "15488": {
        "Name": "Blueger",
        "Number": "73",
        "AorC": "          "
    },
    "15489": {
        "Name": "Duhaime",
        "Number": "24",
        "AorC": "          "
    },
    "15490": {
        "Name": "Groulx",
        "Number": "29",
        "AorC": "          "
    },
    "15491": {
        "Name": "Haymes",
        "Number": "43",
        "AorC": "          "
    },
    "15492": {
        "Name": "MacEwen",
        "Number": "19",
        "AorC": "          "
    },
    "15493": {
        "Name": "Roslovic",
        "Number": "96",
        "AorC": "          "
    },
    "15494": {
        "Name": "Sissons",
        "Number": "15",
        "AorC": "          "
    },
    "15495": {
        "Name": "Marchenko",
        "Number": "86",
        "AorC": "          "
    },
}

interface NhlDetailsProps {
  fullWizardData: 
    {
      jerseyType: string,
      namebar: "Yes"|"No",
      size: string,
      team: string,
      type: "Official",
      extraData?: {
        teamName: string;
        jerseyTypeName: string;
      },
      qty: { itemid: string, sku: string, uofm: string, qty: number, eachPrice: number, extraData?: { AorC: string; Name: string, Number: string } }[]
    }
    |
    {
      jerseyType: string,
      namebar: "Yes"|"No",
      size: string,
      team: string,
      type: "Personalized",
      extraData?: {
        teamName: string;
        jerseyTypeName: string;
      },
      qty: { number: string, name: string, sku: string, uofm: string, qty: number, eachPrice: number, aorc?: string }[]
    }
    |
    {
      jerseyType: string,
      namebar: "Yes"|"No",
      size: string,
      team: string,
      type: "OrderAC",
      extraData?: {
        teamName: string;
        jerseyTypeName: string;
      },
      qty: { itemid: string, sku: string, uofm: string, qty: number, eachPrice: number }[]
    }
  isPrintView?: boolean;
}

const NhlDetails: React.FC<NhlDetailsProps> = ({ fullWizardData, isPrintView = false }) => {
  const typeText = fullWizardData.type === "Official" ? "NHL Official Kits" : fullWizardData.type === "Personalized" ? "NHL Personalized Kits" : "NHL A or C Order Kits";
  const columns = styles.twoColumns;
  const rowStyle = isPrintView
    ? "flex flex-row flex-wrap w-full px-0 py-[0.25em] border-b-[rgb(218,218,218)] border-b border-solid grid grid-cols-[25%_75%] gap-4"
    : styles.lnRow;

  const data:{name:string,value:any}[] = [];

  switch (fullWizardData.type) {
    case "Official":
      data.push(
        { name: "Team", value: fullWizardData.extraData?.teamName ?? teamNameById[fullWizardData.team as keyof typeof teamNameById] },
        { name: "Jersey Type", value: fullWizardData.extraData?.jerseyTypeName ?? jerseyTypeById[fullWizardData.jerseyType as keyof typeof jerseyTypeById] },
        { name: "Size", value: fullWizardData.size },
        { name: "Namebar", value: fullWizardData.namebar },
      )
      for (let i = 0; i < fullWizardData.qty.length; i++) {
        const playerData = !!fullWizardData.qty[i].extraData ?
          fullWizardData.qty[i].extraData! :
          playersById[fullWizardData.qty[i].itemid as keyof typeof playersById];
        data.push(
          { name: "Number and name", value: playerData.Number + " - " + playerData.Name },
          { name: "A or C", value: playerData.AorC.trim() },
          { name: "Quantity", value: fullWizardData.qty[i].qty },
        )
      }
      break;
    case "Personalized":
      data.push(
        { name: "Team", value: fullWizardData.extraData?.teamName ?? teamNameById[fullWizardData.team as keyof typeof teamNameById] },
        { name: "Jersey Type", value: fullWizardData.extraData?.jerseyTypeName ?? jerseyTypeById[fullWizardData.jerseyType as keyof typeof jerseyTypeById] },
        { name: "Size", value: fullWizardData.size },
        { name: "Namebar", value: fullWizardData.namebar },
      )
      for (let i = 0; i < fullWizardData.qty.length; i++) {
        data.push(
          { name: "Number and name", value: fullWizardData.qty[i].number + " - " + fullWizardData.qty[i].name },
          { name: "A or C", value: fullWizardData.qty[i].aorc?.trim() },
          { name: "Quantity", value: fullWizardData.qty[i].qty },
        )
      }
      break;
    case "OrderAC":
      data.push(
        { name: "Team", value: fullWizardData.extraData?.teamName ?? teamNameById[fullWizardData.team as keyof typeof teamNameById] },
        { name: "Jersey Type", value: fullWizardData.extraData?.jerseyTypeName ?? jerseyTypeById[fullWizardData.jerseyType as keyof typeof jerseyTypeById] },
        { name: "Size", value: fullWizardData.size },
        { name: "Namebar", value: fullWizardData.namebar },
      )
      for (let i = 0; i < fullWizardData.qty.length; i++) {
        data.push(
          { name: "A or C", value: fullWizardData.qty[i].itemid },
          { name: "Quantity", value: fullWizardData.qty[i].qty },
        )
      }
      break;
  }

  return (
    <>
      <div className={[styles.card, columns, styles.lnCard, isPrintView && "text-sm"].join(' ')}>
        <h3 className={`uppercase text-[#F36E29] font-bold ${!isPrintView ? 'pt-[1.5em] pb-0 px-[1.5em]' : 'mb-4'}`}>Design Details{isPrintView ? ` - ${typeText}` : ""}</h3>

        {/* Design Details */}
        <div className={`${styles.cardBody} ${isPrintView ? "mr-2" : ""}`}>
          {!isPrintView &&
            <div className={rowStyle}>
              <span className={[styles.value, "pb-2 text-lg text-center w-full"].join(' ')}>{typeText}</span>
            </div>
          }
          {data?.length ? data.map(({ name, value }) => {
            const displayValue = value;

            return displayValue ? (
              <div className={rowStyle} key={name}>
                <span className={styles.name}>{`${name}:`}</span>
                <span className={styles.value}>{displayValue}</span>
              </div>
            ) : null;
          }) : null}
        </div>
      </div>
    </>
  );
};

export default NhlDetails;